export default {
    route: {
        dashboard: 'Deais',
        article: 'Ailt',
    },
    month: {
        jan: 'Eanáir',
        feb: 'Feabhra',
        mar: 'Márta',
        apr: 'Aibreán',
        may: 'Bealtaine',
        jun: 'Meitheamh',
        jul: 'Iúil',
        aug: 'Lúnasa',
        sep: 'Meán Fómhair',
        oct: 'Deireadh Fómhair',
        nov: 'Samhain',
        dec: 'Nollaig',
    },
    week: {
        mon: 'Lú',
        tue: 'Má',
        wed: 'Cé',
        thu: 'Dé',
        fri: 'Ao',
        sat: 'Sa',
        sun: 'Do',
    },
    navbar: {
        logOut: 'Logáil Amach',
        myProfile: 'Mo phróifíl',
        termsConditions: 'Téarmaí',
    },
    login: {
        title: 'Logáil isteach : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        logIn: 'Logáil isteach',
        username: 'Ainm úsáideora',
        password: 'Pasfhocal',
        loginForm: {
            header: 'Fáilte go ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Cuir isteach an cód ó do fhíordheimhnitheoir.',
            subheader: 'Cuir isteach an cód 6 dhigit thíos chun leanúint ar aghaidh',
            placeholderSecurityCode: 'Cuir isteach Cód Slándála anseo',
        },
        forgotPassword: {
            header: 'Ar rinne tú dearmad ar do Phásfhocail?',
            subheader: 'Cuir isteach do r-phost thíos agus seolfaimid teachtaireacht chun do phasfhocal a athshocrú',
            placeholderEmail: 'Cuir isteach do r-phost',
        },
        resetPassord: {
            header: 'Athshocraigh do phasfhocal.',
            subheader: 'Cuir isteach an cód a sheolamar chugat agus athshocraigh do phasfhocal.',
            placeholder: {
                code: 'Cuir isteach do chód',
                newPassWord: 'Cuir isteach do phasfhocal nua',
                confirmPassWord: 'Athdhearbhaigh do phasfhocal',
            },
            success: 'Athshocraíodh do phasfhocal go rathúil.',
        },
        button: {
            login: 'Logáil isteach',
            forgotPassword: 'Dearmad ar pasfhocal?',
            resetMyPassword: 'Athshocraigh mo phasfhocal',
            submitMyPassword: 'Sábháil pasfhocal nua',
            back: 'Ar ais',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Cuimhnigh orm',
            password: 'Pasfhocal',
            userId: 'ID Úsáideora',
            copyright: 'Cóipcheart ##COMPANY_BRAND_NAME##.',
            showPassword: 'Taispeáin Pasfhocal',
            hidePassword: 'Folaigh Pasfhocal',
        },
        errors: {
            email: {
                email: 'Cuir isteach seoladh ríomhphoist bailí.',
                required: 'Cuir isteach do ríomhphost le do thoil.',
            },
            password: {
                required: 'Cuir isteach do phasfhocal.',
                max: 'Caithfidh pasfhocal a bheith 8 gcarachtar ar a laghad ar fad',
            },
            securityCode: {
                required: 'Cuir isteach do chód slándála.',
                max: 'Caithfidh an cód slándála a bheith 6 charachtar ar a laghad',
            },
            verificationCodeInvalid: 'Cód fíoraithe neamhbhailí.',
            generalError: "Earráid agus d'iarratas á phróiseáil.",
            incorrectCredentials: 'Ainm úsáideora nó pasfhocal mícheart.',
            defaultPasswordExpired: 'Tá do phasfhocal imithe in éag agus ní mór do riarthóir é a athshocrú.',
            inValidEmailAddress: 'Tá an seoladh ríomhphoist neamhbhailí.',
            securityCodeInvalid: 'Cód slándála neamhbhailí.',
            verificationCodeFormat: 'Cuir isteach cód fíorúcháin 6 dhigit.',
            passwordFormat:
                'Caithfidh 15 charachtar a bheith sa phasfhocal, le ar a laghad litir chás uachtair amháin, litir bheag, carachtar speisialta agus uimhir amháin.',
            confirmPasswordMatch: 'Ní hionann pasfhocal agus pasfhocal athdhearbhaigh.',
            common: 'Tharla earráid, bain triail eile as.',
        },
        toast: {
            error: 'Tharla earráid, bain triail eile as.',
        },
    },
    dashboard: {
        title: 'Baile : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Deais',
        formtitle: 'Bailíochtú Foirme',
        label: {
            pending: 'Ar feitheamh',
            currentBalance: 'Iarmheid reatha',
            closingBalance: 'Iarmhéid Deiridh',
            availableCredit: 'Creidmheas ar Fáil',
            unbilledAmount: 'Méid Neamhbhilleáilte',
            filter: 'Scagaire',
            reportTags: 'Clibeanna Tuairisce',
            driverGroup: 'Grúpa tiománaí',
            selectDriverGroup: 'Roghnaigh Grúpaí Tiománaithe',
            selectTags: 'Roghnaigh Clibeanna',
            dateRange: 'Raon Dáta',
            month: 'Mí',
            year: 'Bliain',
            day: 'Lá',
            week: 'Seachtain',
            userSessionTitle: 'Seisiúin tiománaí',
            userSessions: 'Seisiúin tiománaí',
            expenseTitle: 'Suim Costais',
            expense: 'Costas',
            energyTitle: 'Suim Fuinnimh (kWh)',
            enrgy: 'Fuinneamh',
            averageTransationTitle: 'Meán Idirbhearta',
            transaction: 'Idirbheart',
            creditLimit: 'Teorainn Chreidmheasa',
            totalDriverAccounts: 'Iomlán cuntais tiománaithe',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
        },
        button: {
            apply: 'Cuir iarratas isteach',
            clear: 'Glan',
        },
        cpoType: {
            Both: 'An dá',
            Local: 'Áitiúil',
            International: 'Idirnáisiúnta',
        },
    },
    permission: {
        createArticle: 'Cuir Airteagal leis',
        editArticle: 'Cuir Airteagal in eagar',
        save: 'Sábháil',
        confirm: 'An bhfuil tú cinnte?',
        cancel: 'Cealaigh',
        update: 'Nuashonrú',
    },
    table: {
        pagination: {
            prev: 'Roimhe seo',
            nrev: 'Ar aghaidh',
            showing: 'Ag taispeáint',
        },
        data: {
            noData: 'Níor aimsíodh aon sonraí.',
        },
    },
    article: {
        title: 'Airteagal a bhainistiú',
        id: 'Aitheantas an Airteagail',
        date: 'Dáta',
        tabletitle: 'Teideal',
        author: 'Údar',
        reviewer: 'Athbhreithneoir',
        actions: 'Gníomhartha',
        saveMessage: 'Airteagal Sábháil go rathúil',
        updateMessage: 'Airteagal Nuashonraithe go rathúil',
        deleteMessage: 'Scriosadh an t-alt go rathúil',
    },
    user: {
        title: 'Úsáideoirí: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        user: 'Úsáideoirí',
        manageUser: 'Bainistigh Úsáideoir',
        placeholder: {
            name: 'Ainm',
            email: 'Seoladh ríomhphoist',
            phoneNo: 'Fón Uimh.',
            firstName: 'Ainm',
            lastName: 'Sloinne',
            userGroup: 'Grúpaí Úsáideoirí',
            userRoles: 'Róil Úsáideora',
            Organisation: 'Eagraíocht',
            select: 'Roghnaigh Stádas',
            selectOrganisation: 'Roghnaigh Eagraíocht',
            selectUserGroup: 'Roghnaigh Grúpa Úsáideoirí',
            languagePreference: 'Rogha Teanga',
        },
        label: {
            firstName: 'Ainm',
            lastName: 'Sloinne',
            email: 'Ríomhphost',
            phoneNo: 'Fón Uimh.',
            optional: '(Roghnach)',
            userGroups: 'Grúpaí Úsáideoirí',
            userRoles: 'Róil Úsáideora',
            Organisation: 'Eagraíocht',
            createdDate: 'Dáta Cruthaithe',
            languagePreference: 'Rogha Teanga',
            id: 'Id',
            action: 'Gníomh',
            status: 'Stádas',
            name: 'Ainm',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            all: 'Gach',
            disable: 'Díchumasaigh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            pending: 'Ar feitheamh',
            reset2FA: 'Athshocraigh 2FA',
            deleted: 'Scriosta',
            lastLoginDate: 'Dáta Logála Isteach Deiridh',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            sendEmail: 'Seol Ríomhphost',
            reset2FA: 'Athshocraigh 2FA',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            sendMailConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat ríomhphost a sheoladh?',
            mailSentSuccessMessage: 'Seoladh ríomhphoist go rathúil.',
            reset2FAConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat 2FA a athshocrú don úsáideoir seo?',
        },
        errors: {
            email: {
                required: 'Cuir isteach seoladh ríomhphoist',
                email: 'Cuir isteach seoladh ríomhphoist bailí',
            },
            firstName: {
                required: 'Cuir isteach céad ainm le do thoil',
                valid: 'Cuir isteach céad ainm bailí',
            },
            lastName: {
                required: 'Cuir isteach sloinne le do thoil',
                valid: 'Cuir isteach sloinne bailí le do thoil',
            },
            phoneNo: {
                required: 'Cuir isteach uimhir theileafóin le do thoil',
                match: 'Cuir isteach uimhir theileafóin bhailí',
            },
            userGroups: {
                required: 'Roghnaigh Grúpa Úsáideoirí amháin ar a laghad',
            },
            organization: {
                required: 'Roghnaigh eagraíocht le do thoil',
            },
        },
    },
    userGroup: {
        title: 'Grúpaí Úsáideoirí : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        manageUserGroup: 'Bainistigh Grúpa Úsáideoirí',
        users: 'Úsáideoirí',
        header: 'Grúpaí Úsáideoirí',
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            yes: 'Tá',
            no: 'Níl',
            action: 'Gníomh',
            add: 'Cuir',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            permission: 'Cead Rochtana',
        },
        placeholder: {
            groupName: 'Ainm an Ghrúpa',
            users: 'Roghnaigh Úsáideoirí',
            select: 'Roghnaigh Stádas',
            organisation: 'Roghnaigh Eagraíocht',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                "Agus an grúpa eagraíochta seo á scriosadh, bainfimid comhlachas grúpa d'eagraíocht ar leith, an bhfuil tú cinnte gur mhaith leat leanúint ar aghaidh?",
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        label: {
            id: 'Id',
            name: 'Ainm',
            description: 'Cur síos',
            Organisation: 'Eagraíocht',
            createdBy: 'Cruthaithe ag',
            status: 'Stádas',
            modifiedBy: 'Athraithe De réir',
            createdDate: 'Dáta Cruthaithe',
            modifiedDate: 'Dáta Athraithe',
            action: 'Gníomh',
            groupName: 'Ainm an Ghrúpa',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            phoneNo: 'Uimhir teileafón',
            email: 'Seoladh ríomhphoist',
            groupAccess: 'Rochtain Ghrúpa',
            selectUsers: 'Roghnaigh Úsáideoirí',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            yes: 'Tá',
            no: 'Níl',
        },
        form: {
            groupName: {
                label: 'Ainm an Ghrúpa',
                placeholder: 'Cuir isteach ainm an ghrúpa',
            },
            description: {
                label: 'Cur síos',
                placeholder: 'Iontráil cur síos',
            },
            Organisation: {
                label: 'Eagraíocht',
            },
        },
        errors: {
            groupName: {
                required: 'Cuir isteach ainm an ghrúpa',
                valid: 'Cuir isteach ainm bailí an ghrúpa',
                max: '50 carachtar ar a mhéad a cheadaítear',
            },
            description: {
                max: '255 carachtar ar a mhéad a cheadaítear',
            },
            userList: {
                required: 'Roghnaigh úsáideoir amháin ar a laghad',
            },
        },
        permission: {
            header: 'Cead',
            label: {
                module: 'Modúl',
                subModule: 'Fo-mhodúl',
                action: 'Gníomh',
            },
        },
    },
    transactions: {
        headerTitle: 'Idirbhearta Tiománaí - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        title: 'Idirbhearta tiománaí',
        transaction: 'Idirbheart',
        columns: {
            amount: 'Méid',
            location: 'Suíomh',
            date: 'Dáta',
            milesAdded: 'Mílte Curtha leis',
            time: 'Am',
            cost: 'Costas',
            energy: 'Fuinneamh',
            action: 'Gníomh',
            remark: 'Nótaí',
            credit: 'Creidmheas',
            debit: 'Dochar',
            closing: 'Deiridh',
            transaction: 'ID Idirbhirt',
            name: 'Ainm',
            type: 'Cineál',
            federatedAccount: 'Cineál Cuntais Cónaidhme',
            reference_id: 'Aitheantas tagartha',
            energyCost: 'Costas Fuinnimh',
            fixedCost: 'Costas Seasta',
            chargingTimeCost: 'Costas Ama Luchtaithe',
            parkingTime: 'Am Páirceála',
            parkingCost: 'Costas Páirceála',
            appliedTariff: 'Taraif Fheidhmeach',
            netCost: 'Costas Glan',
            VATRate: 'Ráta CBL',
        },
        form: {
            charge: 'Muirearú',
            payment: 'Íocaíocht',
            month: 'Mí',
        },
        label: {
            exportAll: 'Easpórtáil Uile',
            driver: 'Tiománaí',
            vehicle: 'Feithicil',
            cardPayment: 'Íocaíocht Cárta',
            referralBonus: 'Bónas Atreoraithe',
            rewards: 'luach saothair',
            transactionDetails: 'Sonraí Idirbhirt',
            transaction_id: 'Aitheantas Idirbhirt',
            fullName: 'Ainm iomlán',
            email: 'Ríomhphost',
            phone_number: 'Uimhir teileafón',
            viewFailedPayments: 'Féach ar Íocaíochtaí Teipthe',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            back: 'Ar ais',
        },
        placeholder: {
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            name: 'Ainm',
            chargingStation: 'Port luchtaithe',
            selectType: 'Roghnaigh Cineál',
            transaction: 'ID Idirbhirt',
            reference_id: 'Aitheantas tagartha',
        },
        message: {
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            error: {
                common: 'Chuaigh rud eigin mícheart. ',
            },
        },
    },
    driver: {
        title: 'Tiománaithe: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Tiománaithe',
        manageDriver: 'Tiománaí a bhainistiú',
        startCharge: 'Tosaigh Cianmhuirear',
        activities: 'Gníomhaíochtaí',
        detail: 'Sonraí tiománaí',
        address_detail: 'Seoladh',
        billing_address_detail: 'Seoladh billeála',
        chargeDetails: 'Sonraí Muirir',
        debtLetterHistory: 'Stair Litir Fiach',
        note: 'Nóta: Má tá luach saothair reatha an tiománaí difriúil ó luach saothair nua, beidh a volta reatha imithe i léig.',
        charityAdded: 'Síntiús Carthanachta Curtha leis',
        cd: 'cd',
        placeholder: {
            name: 'Ainm',
            email: 'Seoladh ríomhphoist',
            firstName: 'Ainm',
            lastName: 'Sloinne',
            payment_card: 'Na 4 dhigit dheireanacha den chárta íocaíochta',
            select: {
                status: 'Roghnaigh Stádas',
                account_type: 'Roghnaigh cineál cuntais',
                payment_type: 'Roghnaigh cineál íocaíochta',
                driver_groups: 'Roghnaigh grúpaí tiománaithe',
                driver_tags: 'Roghnaigh clibeanna',
                organization: 'Roghnaigh eagraíocht',
                promotion: 'Roghnaigh cur chun cinn',
            },
            driverGroup: 'Grúpa tiománaí',
            organization: 'Eagraíocht',
            account_type: 'Cineál Cuntais',
            payment_type: 'Cineál Íocaíochta',
            referral_code: 'Cód Atreoraithe',
            driver_tags: 'Clibeanna',
            address: 'Seoladh Líne 1',
            address2: 'Líne seoladh 2',
            city: 'Cathair',
            county: 'Contae',
            postal_code: 'Cód Poist',
            billing_address: 'Seoladh Líne 1',
            billing_address2: 'Líne seoladh 2',
            billing_city: 'Cathair',
            billing_county: 'Contae',
            billing_postal_code: 'Cód Poist',
            promotion: 'Arduithe Céime',
            currentDriverPromotion: 'Cur Chun Cinn Reatha',
            driverPromotionJoinDate: 'Dáta aontaithe',
            chargeLocation: 'Suíomh',
            chargeStation: 'Stáisiún',
            connector: 'Cónascaire',
            limitedKWH: 'kWh teoranta:',
            confirmationNote:
                'Ar mhaithe le slándáil chuntais, deimhnigh céad ainm, sloinne, seoladh líne 1 agus cód poist an tiománaí aonair sula dtosaíonn tú ar an gcianmhuirear. ',
            rfidCard: 'Cárta RFID',
            confirmationNoteFleet: 'Deimhnigh an pasfhocal seo leis an tiománaí le do thoil: ',
            vehicle_number: 'Uimhir Feithicle',
            api_url: 'URL API',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            publicRFID: 'ID Cárta Poiblí RFID',
            languagePreference: 'Rogha Teanga',
            searchAddress: 'Seoladh',
        },
        label: {
            firstName: 'Ainm',
            lastName: 'Sloinne',
            email: 'Ríomhphost',
            group: 'Grúpa',
            driverGroups: 'Grúpa tiománaí',
            driver_tags: 'Clibeanna',
            organization: 'Eagraíocht',
            payment_type: 'Cineál Íocaíochta',
            referral_code: 'Cód Atreoraithe',
            createdDate: 'Dáta Cruthaithe',
            id: 'Id',
            action: 'Gníomh',
            status: 'Stádas',
            account_type: 'Cineál Cuntais',
            type: 'Cineál',
            name: 'Ainm',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            all: 'Gach',
            disable: 'Díchumasaigh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            cancelled: 'Ar ceal',
            deleted: 'Scriosta',
            address: 'Seoladh',
            address2: 'Líne seoladh 2',
            city: 'Cathair',
            county: 'Contae',
            postal_code: 'Cód Poist',
            billing_address: 'Seoladh Líne 1',
            billing_address2: 'Líne seoladh 2',
            billing_city: 'Cathair',
            billing_county: 'Contae',
            billing_postal_code: 'Cód Poist',
            promotion: 'Arduithe Céime',
            expired: " - D'éag",
            currentDriverPromotion: 'Cur Chun Cinn Reatha',
            driverPromotionJoinDate: 'Dáta aontaithe',
            vehicleNumber: 'Uimhir Feithicle',
            paymentCard: 'Cárta Íocaíochta',
            cardType: 'Cineál Cárta',
            cardNumber: 'Cárta Uimh. (4 dhigit dheireanacha)',
            cardTitle: 'Teideal an Chárta',
            cardExpiry: 'Dáta Éaga an Chárta',
            paymentServiceProvider: 'Soláthraí Seirbhíse Íocaíochta',
            viewReferral: 'Amharc ar Atreorú',
            referralDetails: 'Sonraí Atreoraithe',
            referrer_name: 'Ainm an Tarchuir',
            referral_name: 'Ainm Atreoraithe',
            referral_bonus: 'Bónas Atreoraithe',
            referralBonusStatus: 'Stádas Bónas Atreoraithe',
            referee_Name: 'Ainm an Réiteoir',
            noRecords: 'Níl taifid le taispeáint',
            noReferralsMessage: 'Gan Atreorú(í)',
            referrerName: 'Ainm an Mholtóra: ',
            referralCode: 'Cód Atreoraithe an Atreoraithe:',
            noReferrerMessage: 'Gan Atreoraí',
            current_balance: 'Iarmheid reatha',
            referral_balance: 'Iarmhéid Atreoraithe',
            account_balance: 'Iarmhéid Cuntais',
            rewards_balance: 'Iarmhéid Luaíochtaí',
            balanceDetails: 'Sonraí Iarmhéid',
            pending_transactions_details: 'Sonraí na dTríomhlálacha ar Feitheamh',
            pending_balance: 'Iarmhéid ar Feitheamh',
            federated_account_type: 'Cineál Cuntais Cónaidhme',
            pending: 'Ar feitheamh',
            rfidCard: 'Cárta RFID',
            startCharge: 'Tosaigh Cianmhuirear',
            chargeLocation: 'Suíomh',
            chargeStation: 'Stáisiún',
            connector: 'Cónascaire',
            limitedKWH: 'kWh teoranta:',
            confirmationNote:
                'Ar mhaithe le slándáil chuntais, deimhnigh céad ainm, sloinne, seoladh líne 1 agus cód poist an tiománaí aonair sula dtosaíonn tú ar an gcianmhuirear. ',
            fullName: 'Ainm iomlán',
            phoneNo: 'Uimhir teileafón',
            confirmationNoteFleet: 'Deimhnigh an pasfhocal seo leis an tiománaí le do thoil: ',
            chargingStartedMessage: "D'éirigh leis an iarratas cianmhuirir a ardú",
            resetPassword: 'Athshocraigh Pasfhocal',
            password: 'Pasfhocal',
            disablePaymentCard: 'Díchumasaigh Cárta Íocaíochta',
            requestedData: 'Sonraí Iarrtha',
            apiURL: 'API',
            viewData: 'Féach ar Shonraí',
            deletionEmailSent: 'Ríomhphost Scriosta Cuntais Seolta',
            yes: 'Tá',
            onstop: 'Ar Stop',
            badDebtor: 'Drochfhéichiúnaí',
            available: 'Ar fáil',
            languagePreference: 'Rogha Teanga',
            fakeAccount: 'Cuntas Bréige',
            addNotes: 'Cuir Nótaí leis',
            newNote: 'Nóta Nua',
            addNote: 'Cuir nóta',
            existingNotes: 'Nótaí atá ann cheana',
            viewNotes: 'Amharc ar Nótaí',
            notes: 'Nótaí',
            financialDetails: 'Sonraí Airgeadais',
            uniqueID: 'Aitheantas uathúil',
            dateGenerated: 'Dáta Gineadh',
            debtValue: 'Luach Fiach',
            letterTemplate: 'Teimpléad Litreach Úsáidte',
            lastCardValidationDate: 'Dáta bailíochtaithe an Chárta Deiridh',
            cancelPendingTransactions: 'Cealaigh Idirbhearta ar Feitheamh',
            cancelTransactions: 'Cealaigh Idirbhainní',
        },
        pendingTransaction: {
            label: {
                chargeLocation: 'Suíomh',
                chargeStation: 'Stáisiún Luchtaithe',
                sessionId: 'Aitheantas Seisiúin',
                sessionStatus: 'Stádas na Seisiúin',
                amount: 'Méid',
                createdDate: 'Dáta Cruthaithe',
            },
            button: {
                settle: 'Socraigh',
                cancel: 'Cealaigh',
            },
        },
        account_type: {
            driver: 'Tiománaí',
            vehicle: 'Feithicil',
        },
        payment_type: {
            credit_account: 'Cuntas Creidmheasa',
            prepayment_account: 'Cuntas Réamhíocaíochta',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            sendEmail: 'Seol Ríomhphost',
            viewTransactions: 'Féach ar Idirbhearta',
            close: 'Dún',
            startCharge: 'Tosaigh Cianmhuirear',
            startChargeBtn: 'Muirear Tosaigh',
            resetPassword: 'Athshocraigh Pasfhocal',
            submit: 'Cuir isteach',
            amendBalance: 'Leasaigh Iarmhéid',
            viewActivities: 'Féach ar Ghníomhaíochtaí',
            premiumSubscriptions: 'Síntiúis Préimhe',
            markAsFake: 'Marcáil mar Chuntas Bréige',
            addNotes: 'Cuir Nótaí leis',
            debtLetterHistory: 'Stair Litir Fiach',
            enableReferralCode: 'Cumasaigh Cód Atreoraithe',
            disableReferralCode: 'Díchumasaigh an Cód Atreoraithe',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            sendMailConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat ríomhphost a sheoladh?',
            mailSentSuccessMessage: 'Seoladh ríomhphoist go rathúil.',
            resetPasswordConfirmMesage: 'An bhfuil tú cinnte gur mian leat pasfhocal a athshocrú don úsáideoir seo?',
            deleteDriverConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat cuntas an tiománaí seo a scriosadh?',
            markAsFakeConfirmMessage:
                'Ar mhaith leat an cuntas tiománaí seo a mharcáil mar falsa, Is próiseas aontreo é seo ina ndéantar faisnéis a ghlanadh.',
            enableReferralCodeConfirmMesage:
                'An bhfuil tú cinnte gur mhaith leat Cód Atreoraithe a chumasú don tiománaí seo?',
            disableReferralCodeConfirmMesage:
                'An bhfuil tú cinnte gur mhaith leat an Cód Atreoraithe don tiománaí seo a dhíchumasú?',
            cancelPendingTransactionsConfirmMesage:
                'An bhfuil tú cinnte gur mian leat na hidirbhearta ar feitheamh roghnaithe a chealú?',
        },
        errors: {
            driverGroups: {
                required: 'Roghnaigh Grúpa Tiománaithe amháin ar a laghad',
            },
            organization: {
                required: 'Roghnaigh eagraíocht le do thoil',
            },
            tag: {
                invalid_fromat: 'Carachtair neamhbhailí i gClib',
            },
            fullName: {
                valid: 'Cuir isteach ainm bailí',
            },
            phoneNo: {
                match: 'Cuir isteach uimhir theileafóin bhailí',
            },
            email: {
                required: 'Cuir isteach seoladh ríomhphoist',
                email: 'Cuir isteach seoladh ríomhphoist bailí',
            },
            password: {
                passwordFormat:
                    'Caithfidh pasfhocal a bheith 10 gcarachtar, le ar a laghad litir chás uachtair amháin, litir bheag, carachtar speisialta agus uimhir amháin.',
            },
        },
    },
    driverGroup: {
        title: 'Grúpaí Tiománaithe: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        titleFleet: 'Grúpaí : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        manageDriverGroup: 'Bainistigh grúpa tiománaithe',
        manageDriverGroupFleet: 'Bainistigh Grúpa',
        driversList: 'Tiománaithe',
        driversListFleet: 'Tiománaithe/Feithiclí',
        header: 'Grúpa tiománaí',
        headerFleet: 'Grúpaí',
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            yes: 'Tá',
            no: 'Níl',
            action: 'Gníomh',
            add: 'Cuir',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
        },
        placeholder: {
            groupName: 'Ainm an Ghrúpa',
            drivers: 'Roghnaigh Tiománaithe',
            driversFleet: 'Roghnaigh Tiománaithe/Feithiclí',
            select: 'Roghnaigh Stádas',
            selectType: 'Roghnaigh Cineál',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        label: {
            id: 'Id',
            name: 'Ainm',
            description: 'Cur síos',
            organization: 'Eagraíocht',
            createdBy: 'Cruthaithe ag',
            status: 'Stádas',
            modifiedBy: 'Athraithe De réir',
            createdDate: 'Dáta Cruthaithe',
            modifiedDate: 'Dáta Athraithe',
            action: 'Gníomh',
            groupName: 'Ainm an Ghrúpa',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            phoneNo: 'Uimhir teileafón',
            email: 'Seoladh ríomhphoist',
            groupAccess: 'Rochtain Ghrúpa',
            selectDrivers: 'Roghnaigh Tiománaithe',
            selectDriversFleet: 'Roghnaigh Tiománaithe/Feithiclí',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            yes: 'Tá',
            no: 'Níl',
            vehicle_number: 'Feithicil Uimh',
            type: 'Cineál',
            updateDriverAssociation: 'Nuashonrú Cumann Tiománaithe',
            addToThisGroup: 'Cuir Leis an nGrúpa Seo',
            cancel: 'Cealaigh',
        },
        form: {
            groupName: {
                label: 'Ainm an Ghrúpa',
                placeholder: 'Cuir isteach ainm an ghrúpa',
            },
            description: {
                label: 'Cur síos',
                placeholder: 'Iontráil cur síos',
            },
        },
        errors: {
            groupName: {
                required: 'Cuir isteach ainm an ghrúpa',
                valid: 'Cuir isteach ainm bailí an ghrúpa',
                max: '50 carachtar ar a mhéad a cheadaítear',
            },
            description: {
                max: '255 carachtar ar a mhéad a cheadaítear',
            },
            driverList: {
                required: 'Roghnaigh tiománaí amháin ar a laghad',
                requiredfleet: 'Roghnaigh tiománaí/feithicil amháin ar a laghad',
            },
            spendLimit: {
                valid: 'Cuir isteach luach teorann caiteachais amháin ar a laghad',
            },
        },
    },
    vat: {
        title: 'CBL: ##COMPANY_BRAND_NAME##',
        vat: 'CBL',
        manageVat: 'CBL a bhainistiú',
        label: {
            name: 'Ainm',
            description: 'Cur síos',
            rate: 'Ráta',
            createdDate: 'Dáta Cruthaithe',
            action: 'Gníomh',
            status: 'Stádas',
            disabled: 'Faoi mhíchumas',
            enabled: 'Cumasaithe',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            defaultVAT: 'CBL réamhshocraithe',
            yes: 'Tá',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            setDefaultConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat an CBL seo a shocrú mar réamhshocrú?',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            setDefaultVAT: 'socraithe mar Réamhshocrú',
        },
        placeholder: {
            select: 'Roghnaigh Stádas',
            name: 'Ainm',
            description: 'Cur síos',
            rate: 'Ráta',
        },
        errors: {
            name: {
                valid: 'Cuir isteach ainm bailí.',
            },
            rate: {
                max: 'Ní féidir leis an ráta a bheith níos airde ná 100',
                min: 'Ní féidir an ráta a bheith níos lú ná 0',
                number: 'Caithfidh an ráta a bheith ina uimhir',
            },
            description: {
                valid: 'Cuir isteach cur síos bailí',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Tá',
            no: 'Níl',
            proceed: 'Lean ar aghaidh',
            cancel: 'Cealaigh',
        },
    },
    tag: {
        title: 'Clibeanna: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        tag: 'Clibeanna',
        manageUser: 'Bainistigh Úsáideoirí',
        placeholder: {
            name: 'Ainm Clibe',
            select: 'Roghnaigh',
        },
        label: {
            name: 'Ainm Clibe',
            driver_count: 'Comhaireamh Tiománaí',
            charge_location_count: 'Comhaireamh Suímh Táille',
            action: 'Gníomh',
            delete: 'Scrios',
            editHeader: 'Cuir Clib in Eagar',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
        },
        message: {
            deleteConfirmMesage: 'Scriosfar an chlib ó gach tiománaí gaolmhar agus suíomh muirir. ',
        },
        errors: {
            name: 'Carachtair neamhbhailí sa chlib',
        },
    },
    chargeStation: {
        title: 'Stáisiúin Táille : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        chargeStations: 'Stáisiúin Táille',
        manageVat: 'Bainistigh Stáisiún Táille',
        label: {
            modifiedDate: 'Dáta Athraithe',
            importChargeStationHeader: 'Stáisiún Muirear Iompórtála',
            csvFile: 'Comhad CSV',
            manageAmenities: 'Taitneamhachtaí a bhainistiú',
            chargePoint: 'Pointe Muirear',
            allLocations: 'Gach Suíomh',
            assignedLocation: 'Suímh Sannta',
            unassignedLocation: 'Suímh Neamhshannta',
            chargeLocation: {
                cp_id: 'CP-Id',
                type: 'Cineál',
                name: 'Ainm',
                locationName: 'Ainm an tSuímh',
                address: 'Seoladh',
                city: 'Cathair',
                postal_code: 'Cód Poist',
                appliesToOrg: 'Baineann sé leis an Eagraíocht',
                associatedPromotion: 'Cur Chun Cinn Comhlachaithe',
                gmbLocationId: 'Aitheantas Suíomh GMB',
                override_tariff: 'Sobrescribir tarifa',
                cpo: 'CPO',
            },
            chargeStation: {
                uid: 'Uid',
                evse_id: 'ID EVSE',
                status: 'Stádas',
                physicalReference: 'Tagairt Fhisiceach',
                city: 'Cathair',
                postal_code: 'Cód Poist',
            },
            stationConnector: {
                connector_id: 'Aitheantas an Chónascaire',
                standard: 'Caighdeán',
                format: 'Formáid mar Chineál',
                power_type: 'Cineál Cumhachta',
                voltage: 'Voltas',
                amperage: 'Aimpéar',
                power_rating: 'Rátáil Cumhachta',
                override_tariff: 'Sobrescribir tarifa',
            },
            selectTag: 'Roghnaigh Clibeanna',
            addTagHeader: 'Clibeanna Comhlach',
            tags: 'Clibeanna',
            yes: 'Tá',
            assignedTariff: 'Sann Taraif',
            assignTariff: 'Sann Taraif do Shuímh',
            delete: 'Scrios',
            action: 'Gníomh',
            addPromotion: 'Cuir Cur Chun Cinn leis',
            selectPromotion: 'Roghnaigh Cur Chun Cinn',
            exportChargeStations: {
                connector_id: 'cónascaire_id',
                max_power: 'uas_chumhacht',
                cp_id: 'cp_id',
                type: 'cineál',
                location: 'suíomh',
                station_name: 'ainm an stáisiúin',
                address: 'seoladh',
                city: 'chathair',
                postal_code: 'Cód Poist',
                country: 'tír',
                latitude: 'domhanleithead',
                longitude: 'domhanfhad',
                evse_id: 'eis_id',
                standard: 'caighdeánach',
                format: 'formáid',
                powertype: 'cineál cumhachta',
                voltage: 'voltas',
                amperage: 'aimpéar',
            },
            gmbLocationID: 'Aitheantas Suíomh GMB',
            clickHere: 'Cliceáil anseo',
            downloadTemplate: 'chun teimpléad a íoslódáil',
            importStationsModel: 'Múnla Stáisiúin Táille Iompórtála',
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            note: 'Nóta: ',
            autoCalculateMaxPowerNote:
                "Tá roinnt CPOanna cumraithe chun an chumhacht uasta a ríomh go huathoibríoch, trí úsáid a bhaint as an iompórtáil seo d'fhéadfaí na luachanna ríofa sin a ró-scríobh.",
            applyToOrg: 'Cuir i bhfeidhm ar gach Eagraíocht',
        },
        errors: {
            tag: {
                invalid_fromat: 'Carachtair neamhbhailí i gClib',
            },
            file: {
                fileType: "Is féidir comhad leis an síneadh '.csv' a uaslódáil.",
            },
            gmbLocationId: {
                valid: 'Cuir isteach ID Suímh GMB bailí',
            },
            common: 'Chuaigh rud eigin mícheart. ',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            edit: 'Cuir in eagar',
            expand: 'Leathnaigh',
            collapse: 'Laghdaigh',
            import: 'Iompórtáil',
            synchronize: 'Sioncrónaigh',
            syncStation: 'Stáisiún Sioncrónaigh',
            assignTariff: 'Sann Taraif',
            delete: 'Scrios',
            add: 'Cuir',
            addSelected: 'Cuir Roghnaithe',
            addAll: 'Cuir Uile leis',
            yes: 'Tá',
            no: 'Níl',
            back: 'Ar ais',
            apply: 'Cuir iarratas isteach',
            editGMBLocationID: 'Cuir ID Suímh GMB in eagar',
            downloadLocationsData: 'Sliocht Sonraí Suímh Táillí',
            exportAll: 'Easpórtáil Uile',
            importStationsModel: 'Múnla Stáisiúin Táille Iompórtála',
            deleteSelected: 'Scrios Roghnaithe',
            export: 'Easpórtáil',
            viewAssociatedTariffs: 'Ver tarifas asociadas',
        },
        placeholder: {
            selectStationStatus: 'Roghnaigh Stádas',
            name: 'Ainm',
            cp_id: 'CP-Id',
            tags: 'Clibeanna',
            address: 'Seoladh',
            selectTag: 'Roghnaigh Clib',
            evse_id: 'ID EVSE',
            selectChargePoint: 'Roghnaigh CPOanna',
            selectRegion: 'Roghnaigh Réigiún',
            selectPromotion: 'Roghnaigh Cur Chun Cinn',
            gmbLocationID: 'Aitheantas Suíomh GMB',
            selectPowerType: 'Roghnaigh Cineál Cumhachta',
            selectAppliedTariff: 'Roghnaigh Taraif Fheidhmeach',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            addPromotion: "D'éirigh le sonraí an chur chun cinn a nuashonrú",
            updateAmenitiesSuccess: "D'éirigh le háiseanna suíomh muirir a nuashonrú",
            chargePointRequire: 'Teastaíonn pointe luchtaithe amháin ar a laghad',
            deleteBulkConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat taifid roghnaithe a scriosadh?',
            applyToAllOrgConfirmMessage:
                'Ar mhaith leat an taraif seo a chur i bhfeidhm ar eagraíochtaí freisin do gach ionad? ',
        },
        manageAmenities: 'Taitneamhachtaí a bhainistiú',
        chargeStationTariffDetailsModal: {
            header: 'Detalles da tarifa',
            tabsName: {
                general: 'Xeral',
            },
        },
    },
    chargeStationMap: {
        title: 'Amharc Léarscáil na Stáisiúin Táille : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Stáisiúin Táille',
        label: {
            address: 'Seoladh',
            backOfficeUrl: 'URL Cúloifige :',
            amenities: 'Áiseanna:',
            satellite: 'Satailít',
            map: 'Léarscáil',
            search: 'Cuardach',
            refresh: 'Athnuaigh',
            apply: 'Cuir iarratas isteach',
            clear: 'Glan',
            loading: 'Á lódáil...',
        },
        placeholder: {
            locationSearch: 'Stáisiún Cuardaigh',
            mapSearch: 'Cuardaigh de réir ainm sráide, cathrach nó cód poist',
        },
    },
    promotionsRequest: {
        headerTitle:
            'Iarratas um Chur Chun Cinn Tiománaithe - ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        title: 'Iarratas ar Arduithe Céime Tiománaí',
        promotionsRequest: 'Arduithe Céime Iarrtha',
        columns: {
            driverName: 'Ainm tiománaí',
            promotionsName: 'Arduithe Céime Ainm',
            promotionsCode: 'Cód',
            approved: 'Stádas',
            approvedBy: 'Athraithe De réir',
            approvedDate: 'Dáta Athraithe',
            action: 'Gníomh',
            email: 'Ríomhphost',
        },
        form: {
            charge: 'Muirearú',
            payment: 'Íocaíocht',
            month: 'Mí',
        },
        label: {
            approved: 'Ceadaithe',
            pending: 'Ar feitheamh',
            rejected: 'Diúltaithe',
            modelHeader: 'Cur Chun Cinn Iarrtha - ',
            enterComment: 'Cuir isteach do chuid tuairimí',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            back: 'Ar ais',
            approved: 'Cheadaigh',
            pending: 'Ar feitheamh',
            rejected: 'Diúltaigh',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
        },
        placeholder: {
            driverName: 'Ainm tiománaí',
            promotionsName: 'Arduithe Céime Ainm',
            promotionsCode: 'Cód',
            select: 'Roghnaigh Stádas',
        },
        message: {
            ManagestatusMesage:
                'Cliceáil Ceadaithe nó Diúltaithe chun stádas iarratais a chur i bhfeidhm. Nuair a nuashonraítear an t-iarratas seo, ní féidir é a chur in eagar a thuilleadh.',
        },
    },
    driverAccountBalance: {
        title: 'Iarmhéid Cuntas Tiomána: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        driverAccountBalance: 'Iarmhéid cuntas tiománaí',
        manageUser: 'Bainistigh Iarmhéid Cuntas Tiomána',
        placeholder: {
            name: 'Ainm/Ríomhphost',
            select: 'Roghnaigh Stádas',
            payment_type: 'Roghnaigh cineál íocaíochta',
            description: 'Trácht',
            amount: 'Cuir isteach an Méid ar Chreidmheas/Dochar',
        },
        label: {
            name: 'Ainm',
            email: 'Ríomhphost',
            payment_type: 'Cineál Íocaíochta',
            driver_status: 'Stádas Cuntais',
            current_balance: 'Iarmhéid',
            currency: 'Airgeadra',
            driver_id: 'ID tiománaí',
            action: 'Gníomh',
            delete: 'Scrios',
            refundHeader: 'A tharraingt siar',
            creditPayment: 'Cuntas Creidmheasa',
            prePayment: 'Cuntas Réamhíocaíochta',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            refund: 'Leasaigh iarmhéid an chuntais',
            description: 'Trácht',
            amount: 'Cuir isteach an Méid ar Chreidmheas/Dochar',
            additional_payment: 'Íocaíocht Bhreise',
            payment_refunds: 'Aistarraingtí Íocaíochta',
            payment_settlement: 'Leasú Iarmhéid - Iarratas',
            balance: 'Cineál Iarmhéid',
            accountBalance: 'Cistí Cuntas',
            referralBonus: 'Bónas Atreoraithe',
            rewardBalance: 'Iarmhéid Luaíocht',
            total_balance: 'Iarmhéid Iomlán',
            rewards: 'luach saothair',
            pendingBalance: 'Iarmhéid ar Feitheamh',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            send_for_approval: 'Seol le haghaidh Formheasa',
        },
        message: {
            deleteConfirmMesage: 'Scriosfar an chlib ó gach tiománaí gaolmhar agus suíomh muirir. ',
        },
        errors: {
            name: 'Carachtair neamhbhailí sa chlib',
            amount: {
                moreThan: 'Caithfidh an méid a bheith níos mó/níos lú ná 0',
                maxcredit: 'Uasteorainn bainte amach le haghaidh creidmheasa cuntais',
                maxdebit: 'Uasteorainn bainte amach do dhochar cuntais',
            },
        },
    },
    driverPromotions: {
        title: 'Bainistigh Cur Chun Cinn : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        manageDriverPromotion: 'Bainistigh Cur Chun Cinn',
        driverPromotions: 'Arduithe Céime',
        label: {
            name: 'Ainm',
            code: 'Cód',
            errorMessage: 'Teachtaireacht Earráid',
            used: 'Úsáidte',
            unUsed: 'Gan úsáid',
            uploadFileErrorMessage: 'Earráidí agus cóid promóisin á n-uaslódáil.',
            updatePromotionCode: 'Nuashonraigh an Cód Cur Chun Cinn',
            unique_code: 'Cód uathúil',
            uniquePromotionCode: 'Cóid Chur Chun Cinn',
            importDriverPromotionCodeHeader: 'Íoslódáil an cód um chur chun cinn tiománaithe',
            csvFile: 'Cóid Chur Chun Cinn',
            promotionCode: 'Cód Cur Chun Cinn',
            usedBy: 'Úsáidte Ag',
            description: 'Cur síos',
            accountCredit: 'Creidmheas Cuntais',
            discountRatePeriod: 'Tréimhse Ráta Lascaine',
            indays: '(Laethanta)',
            intilakWhRate: 'Ráta tosaigh kWh',
            ivRewardsPromotion: 'IV Cur Chun Cinn Luaíochtaí',
            referralPromotion: 'Cur Chun Cinn Atreoraithe',
            expiryDate: 'Dáta Éaga',
            needApprovalToJoinPromotion: 'Teastaíonn faomhadh chun páirt a ghlacadh sa phromóisin',
            newDriversOnly: 'Tiománaithe nua amháin',
            forOrganisation: 'Don Eagraíocht',
            createdDate: 'Dáta Cruthaithe',
            action: 'Gníomh',
            status: 'Stádas',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            deleted: ' (Scriosta)',
            csvFileSupported: 'Ní thacaítear ach le comhad CSV',
            clickHere: 'Cliceáil anseo',
            downloadTemplate: 'chun teimpléad a íoslódáil',
            exportColumnHeder: 'cóid_bolscaireachta',
            min_kwh_package_promotion: 'kWh íosta',
            package_promotion_period: 'Tréimhse chur chun cinn an phacáiste (Laethanta)',
            package_promotion_volt_bonus: 'Líon na Volta a Bronnadh',
            rfidCardUnitPrice: 'Praghas Aonaid Cárta RFID',
            subscription: 'Síntiús Préimh',
            tariffUpdate: 'Nuashonrú Taraife',
            currentTariff: 'Tarifa de sobrescrición actual',
            next: 'Ar aghaidh',
            newTariff: 'Nova tarifa de sobrescrición',
            save: 'Sábháil',
            override_tariff: 'Sobrescribir tarifa',
            manageOverrideTariff: 'Bainistigh Taraif Forghníomhaithe',
        },
        placeholder: {
            name: 'Ainm',
            promotionCode: 'Cód Cur Chun Cinn',
            selectTariff: 'Roghnaigh Taraif',
            selectStatus: 'Roghnaigh Stádas',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            forOrganisation: 'Don Eagraíocht',
            min_kwh_package_promotion: 'kWh íosta',
            package_promotion_period: 'Tréimhse Chur Chun Cinn Pacáiste',
            package_promotion_volt_bonus: 'Líon na Volta a Bronnadh',
            rfidCardUnitPrice: 'Praghas Aonaid Cárta RFID',
            premium_subscription: 'Síntiús Préimh',
            selectCurrentTariff: 'Seleccionar tarifa de sobrescrición actual',
            selectNewTariff: 'Seleccionar nova tarifa de sobrescrición',
            selectOverrideTariff: 'Roghnaigh Taraif Forghníomhaithe',
        },
        button: {
            update: 'Nuashonrú',
            import: 'Iompórtáil',
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            subscriptionChangeWarningMessage:
                'Rabhadh: Má athraítear an Cineál Síntiúis, cealófar na hathnuachan uathoibríoch ar fad a bhaineann le Cuntais Tiománaithe.',
            tariffUpdateNote: 'Sannfar Taraif Nua do na harduithe céime seo a leanas:',
            updateTariffConfirmMessage:
                'An bhfuil tú cinnte gur mian leat taraif a nuashonrú le haghaidh promóisin roghnaithe?',
            selectOneRecord: 'Roghnaigh cur chun cinn amháin ar a laghad le haghaidh nuashonrú taraife',
        },
        errors: {
            promotionName: {
                valid: 'Cuir isteach ainm promóisin bailí',
            },
            promotionCode: {
                valid: 'Cuir isteach cód promóisin bailí',
            },
            accountCredit: {
                moreThan: 'Caithfidh Creidmheas Cuntais a bheith níos mó ná 0',
                max: 'Uasteorainn bainte amach le haghaidh creidmheasa cuntais',
                typeError: 'Cuir isteach méid creidmheasa cuntais bhailí',
            },
            discountRatePeriod: {
                moreThan: 'Caithfidh Tréimhse an Ráta Lascaine a bheith níos mó ná 0',
            },
            intialRate: {
                max: 'Ní féidir leis an ráta a bheith níos airde ná 100',
                min: 'Ní féidir an ráta a bheith níos lú ná 0',
                typeError: 'Cuir isteach ráta bailí',
            },
            common: 'Tharla earráid, bain triail eile as.',
            file: {
                fileType: "Is féidir comhad leis an síneadh '.csv' a uaslódáil.",
            },
            maxValue: 'Ní ceadmhach don uasluach a bheith níos mó ná 2147483647',
            rfidCardUnitPrice: {
                max: 'Ní féidir le Praghas Aonaid Cárta RFID a bheith níos mó ná 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle: 'Faomhadh Iarmhéid Cuntais - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        title: 'Faomhadh Iarmhéid Cuntais',
        transaction: 'Idirbheart',
        columns: {
            email: 'Ríomhphost',
            amount: 'Méid',
            status: 'Stádas',
            request_by: 'Iarrtha ag',
            request_date: 'Iarrtha Ar',
            request_by_comment: 'Iarrtha ag Tuairimí',
            review_by: 'Athbhreithnithe ag',
            review_date: 'Athbhreithnithe Ar',
            review_comment: 'Tuairimí an Athbhreithneora',
            credit: 'Creidmheas',
            debit: 'Dochar',
            closing: 'Deiridh',
            transaction: 'ID Idirbhirt',
            name: 'Ainm',
            action: 'Gníomh',
            request_type: 'Cineál Iarratas',
            invoice: 'Sonrasc',
        },
        form: {
            driver: 'Tiománaí',
            organisation: 'Eagraíocht',
            month: 'Mí',
        },
        label: {
            request_type: 'Cineál Iarratas',
            refundHeader: 'Leasú Iarmhéid',
            pending: 'Ar feitheamh',
            approved: 'Cheadaigh',
            declined: 'Meath',
            approve: 'Cheadaigh',
            decline: 'Meath',
            comment: 'Cuir isteach do chuid tuairimí',
            status: 'Stádas',
            refund: 'Creidmheas/Dochar a cheadú',
            refundAmount: 'Méid Aistarraingthe ',
            commentsFrom: 'Tuairimí ó',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
        },
        placeholder: {
            comment: 'Cuir isteach do chuid tuairimí',
            status: 'Roghnaigh Stádas',
            name: 'Ainm/Ríomhphost',
            refundAmount: 'Méid Aistarraingthe ',
        },
        message: {
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            selectApprovalOrReject: 'Ceadaigh/Diúltaigh an t-iarratas seo.',
        },
    },
    paymentScheduleSetting: {
        title: 'Socrú Sceideal Íocaíochta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Sceideal Íocaíochta',
        note: ' Sceidil post Cúlra chun billí gan íoc a ghlanadh do mhuirearú EV a dhéanann Tiománaithe.',
        placeholder: {
            day_of_week: 'Lá na Seachtaine',
        },
        label: {
            daily: 'laethúil',
            weekly: 'Seachtainiúil',
            day_of_week: 'Lá na Seachtaine',
            selectDay: 'Roghnaigh Lá',
        },
        day_of_week: {
            monday: 'DÉ LUAIN',
            tuesday: 'DÉ MÁIRT',
            wednesday: 'DÉ CÉADAOIN',
            thursday: 'DÉARDAOIN',
            friday: 'DÉ hAoine',
            saturday: 'DÉ SATHAIRN',
            sunday: 'DOMHNACH',
        },
        button: {
            save: 'Sábháil',
        },
    },
    paymentFailures: {
        title: 'Teipeanna Íocaíochta: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        managePaymentFailures: 'Teipeanna Íocaíochta',
        placeholder: {
            name: 'Ainm/Ríomhphost',
            note: 'Athmharc',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            select: 'Roghnaigh Stádas',
            status: 'Roghnaigh stádas',
            failureReason: 'Cúis Teip',
        },
        label: {
            name: 'Ainm',
            email: 'Ríomhphost',
            transaction_id: 'ID Idirbhirt',
            total_amount: 'Iomlán',
            currency_name: 'Airgeadra',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            note: 'Athmharc',
            action: 'Gníomh',
            editHeader: 'Nuashonraigh an Stádas Íocaíochta',
            pending: 'Ar feitheamh',
            acknowledged: 'Admhaítear',
            closed: 'Dúnta',
            transactionDetails: 'Sonraí Idirbhirt',
            transaction_request: 'Iarratas ar Idirbheart',
            transaction_response: 'Freagra Idirbheart',
            error_message: 'Teachtaireacht Earráid',
            error_code: 'Cód Earráide',
            request_type: 'Cineál Iarratas',
            response_code: 'Cód Freagartha',
            response_code_description: 'Tuairisc Cód Freagartha',
            null_data: 'Níor aimsíodh aon sonraí',
            transaction_date: 'Dáta Idirbhirt',
            failureReason: 'Cúis Teip',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir Stádas in Eagar',
            reset: 'Athshocraigh',
            yes: 'Tá',
            no: 'Níl',
            action: 'Gníomh',
            back: 'Ar ais',
        },
    },
    chargeTariff: {
        title: 'Taraifí: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Taraifí',
        tariff: 'Taraif',
        columns: {
            location: 'Suíomh',
            chargeStation: 'Ainm an Stáisiúin Luchtaithe',
            connector: 'Cónascaire',
            standard: 'Caighdeán',
        },
        label: {
            name: 'Ainm',
            vat_name: 'Ainm CBL',
            vat_rate: 'Ráta (%)',
            vat_description: 'Cur síos',
            cpo_id: 'cpo ID',
            action: 'Gníomh',
            url: 'URL',
            currency: 'Airgeadra',
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            enabled: 'Cumasaithe',
            deleted: 'Scriosta',
            detail: 'Sonraigh',
            promotions: 'Arduithe Céime',
            lastUpdated: 'Nuashonraíodh an uair dheireanach ar',
            promotionCode: 'Cód Cur Chun Cinn',
            description: 'Cur síos',
            expiryDate: 'Dáta Éaga',
            priceComponents: 'Comhpháirteanna Praghas',
            priceComponent: 'Comhpháirt Praghas',
            type: 'CINEÁL',
            price: 'PRAGHAS',
            pricePerHour: 'Praghas (in aghaidh na huaire)',
            restriction: 'Srian',
            startDate: 'Dáta tosaigh',
            startTime: 'Am Tosaigh',
            endDate: 'Dáta deiridh',
            endTime: 'Am Deiridh',
            minkWh: 'Íosta kWh',
            maxkWh: 'Uas kWh',
            minPower: 'Cumhacht Min',
            maxPower: 'Cumhacht Max',
            minDuration: 'Íosfhad',
            maxDuration: 'Fad uasta',
            weekDays: 'Laethanta na Seachtaine',
            selectVat: 'Roghnaigh CBL',
            attachVat: 'Ceangail CBL',
            vatdetail: 'Sonraí CBL',
            editVAT: 'Cuir Cineál CBL in eagar',
            vatType: 'Cineál CBL',
            tariffID: 'Aitheantas Taraife',
            element: 'GNÉ',
            prices: 'Praghsanna',
            restrictions: 'Srianta',
            stepSize: 'CÉIM MHÉID',
            vat: 'CBL',
            date: 'DÁTA',
            time: 'AM',
            kwh: 'KWH',
            power: 'CUMHACHT (KW)',
            duration: 'FAID (SEC)',
            current: 'SRUTH (AMP)',
            maxCurrent: 'Sruth Uasta',
            minCurrent: 'Sruth Íosta',
            restrictionTitle: 'SRIANTACHÁN',
            details: 'Sonraí',
            weekDaysTitle: 'LAETHANTA NA SEACHTAINE',
            maxKwhTitle: 'KWH Uasta',
            minKwhTitle: 'KWH Íosta',
            accessGroups: 'Grúpaí Rochtana',
            locations: 'Suímh',
            CPOs: 'CPO-ak',
            connectors: 'Ceanglóirí',
        },
        placeholder: {
            name: 'Ainm',
            selectStatus: 'Roghnaigh Stádas',
            selectVat: 'Roghnaigh CBL',
            selectType: 'Roghnaigh Cineál CBL',
            tariffID: 'Aitheantas Taraife',
            vatType: 'Cineál CBL',
            currency: 'Airgeadra',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            detail: 'Sonraigh',
            add: 'Cuir',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            editvat: 'Ceangail CBL',
            editVAT: 'Cuir Cineál CBL in eagar',
            groupRestrictions: 'Srianta Taraife Grúpa',
            ungroupRestrictions: 'Srianta Taraife Neamhghrúpa',
        },
        noRestrictionAvailable: 'Níl Srianta ar Fáil',
    },
    partnerPromotion: {
        title: 'Arduithe Céime : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Arduithe Céime Comhpháirtithe',
        placeholder: {
            nameorcompany: 'Ainm nó Cuideachta',
            status: 'Roghnaigh Stádas',
            date_from: 'Dáta tosaigh',
            date_to: 'Dáta deiridh',
        },
        label: {
            name: 'Ainm',
            company: 'Cuideachta',
            description: 'Cur síos',
            date_from: 'Dáta tosaigh',
            date_to: 'Dáta deiridh',
            expiry_date: 'Dáta Éaga',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            delete: 'Scrios',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            add: 'Cuir',
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            chargeStation: 'Stáisiúin Táille',
            preview: 'Réamhamharc',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        insert: {
            header: 'Bainistigh Arduithe Céime Comhpháirtithe',
            placeholder: {
                name: 'Ainm',
                company: 'Eolas Cuideachta',
                description: 'Cur síos',
                start_date: 'Dáta tosaigh',
                expiry_date: 'Dáta Éaga',
                offer_duration: '60 Nóiméad',
                stored_for_future_use_days: '2 lá',
                qr_code_details: 'Eolas faoin gCód QR',
                certificate: 'Teastas',
                image: 'Tairiscint Íomhá',
                image1: 'Íomhá Breise 1',
                image2: 'Íomhá Breise 2',
                image3: 'Íomhá Breise 3',
                image4: 'Íomhá Breise 4',
                image5: 'Íomhá Breise 5',
                banner_image: 'Lógó Cur Chun Cinn',
                locationPageImage: 'Íomhá Leathanach Suímh',
                displayOnChargeLocation: 'Scáileán Suímh Taispeána Ar Tháille',
                promotion_button_text: 'Téacs Cnaipe Cur Chun Cinn',
            },
            label: {
                name: 'Ainm',
                company: 'Cuideachta',
                description: 'Cur síos',
                start_date: 'Dáta tosaigh',
                expiry_date: 'Dáta Éaga',
                offer_duration: 'Fad na Tairisceana (Nóiméid)',
                stored_for_future_use_days: 'Sábháil le húsáid sa todhchaí (laethanta)',
                always_display_on_partner_promotion: 'Taispeáin Cur Chun Cinn Comhpháirtithe i gcónaí',
                qr_code_details: 'Cód QR',
                certificate: 'Teastas',
                image: 'Tairiscint Íomhá',
                banner_image: 'Lógó Cur Chun Cinn (1030 X 430)',
                layout: 'Leagan Amach Scáileáin',
                note1: 'Tabhair faoi deara go bhfuil, Ní mór duit a lua <strong>##image##</strong> agus <strong>##qrcode##</strong> leagan amach thar scáileán HTML chun na sonraí faoi seach a athsholáthar dá réir.  ##image0X##, áit ar féidir le X raon ó 1 go 5.',
                qr_code_note:
                    'Tabhair faoi deara go bhfuil, Ní mór duit a lua <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> agus <strong>##ChargeStationAddress##</strong> thar QR Code chun na sonraí faoi seach a athsholáthar dá réir.',
                locationPageImage: 'Íomhá Leathanach Suímh',
                displayOnChargeLocation: 'Scáileán Suímh Taispeána Ar Tháille',
                partner_promotion_display_type: 'Cineál Taispeána Cur Chun Cinn',
                promotion_button_text: 'Téacs Cnaipe Cur Chun Cinn',
                open_external_url: 'Oscail URL Seachtrach',
                external_url: 'URL seachtrach',
                image1: 'Íomhá Breise 1',
                image2: 'Íomhá Breise 2',
                image3: 'Íomhá Breise 3',
                image4: 'Íomhá Breise 4',
                image5: 'Íomhá Breise 5',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm promóisin bailí',
                    max: 'Tá an t-ainm cur chun cinn ró-mhór',
                },
                description: {
                    max: 'Tá cur síos ar chur chun cinn ró-mhór',
                },
                offer_duration: {
                    moreThan: 'Caithfidh fad na tairisceana a bheith níos mó ná 0',
                    max: 'Ní fhéadfaidh ré na tairisceana a bheith níos mó ná 60 nóiméad',
                },
                stored_for_future_use_days: {
                    moreThan: 'Ní mór níos mó ná 0 lá a stóráil le haghaidh úsáide sa todhchaí',
                    max: 'Ní féidir a stóráil le haghaidh úsáide sa todhchaí lá a bheith níos mó ná 99 lá',
                },
                banner_image: {
                    dimensions: 'Caithfidh toise 1030 X 430 a bheith ag an Lógó Cur Chun Cinn',
                },
                image: {
                    fileType: "Is féidir comhad leis an iarmhír '.jpg', '.png', '.svg', '.jpeg' a uaslódáil",
                    location_page_image: 'Is réimse riachtanach í an íomhá Leathanach Suímh',
                },
                certificate: {
                    fileType: "Is féidir comhad leis an síneadh '.crt', '.cer' a uaslódáil",
                },
                promotion_button_text: {
                    valid: 'Cuir isteach téacs bailí cnaipe promóisin',
                },
                external_url: {
                    url: 'Caithfidh URL seachtrach a bheith ina URL bailí',
                },
            },
        },
        assign: {
            header: 'Stáisiúin Táille',
            headerModal: 'Stáisiún Táille',
            placeholder: {
                name: 'Cuir isteach ainm',
                locationName: 'Cuir isteach Ainm an tSuímh',
                address: 'Seoladh',
                tags: 'Roghnaigh Clibeanna',
            },
            label: {
                add: 'Cuir',
                name: 'Ainm',
                type: 'Cineál',
                address: 'Seoladh',
                city: 'Cathair',
                postcode: 'Cód Poist',
                last_updated: 'Dáta Athraithe',
                action: 'Gníomh',
                delete: 'Scrios',
            },
            button: {
                delete: 'Scrios',
            },
            message: {
                deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            },
        },
    },
    CPOInterface: {
        title: 'Cuntais : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Cuntais',
        placeholder: {
            name: 'Ainm',
            status: 'Roghnaigh Stádas',
        },
        label: {
            name: 'Ainm',
            party_id: 'Aitheantas an Pháirtí',
            country_code: 'Cód Tíre',
            version_url: 'URL an leagan',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            locationGroup: 'Suíomh Grúpa',
            yes: 'Tá',
            no: 'Níl',
            rfidDriverTokens: 'Comhroinn ach comharthaí tiománaithe RFID',
            vat_type: 'Cineál CBL',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: '##COMPANY_BRAND_NAME## OCÉ Idirnáisiúnta',
            cpo_type: 'Cineál CPO',
            override_tariff: 'Taraif a Shárú',
            provides_session_total_cost_updates: 'Soláthraíonn Nuashonruithe Ar Chostas Iomlán Na Seisiúin',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            add: 'Cuir',
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            getCredentials: 'Faigh Dintiúir',
            performHandshake: 'Déan Láimhe',
            reHandshake: 'Láimhe arís',
            generateHandshakeToken: 'Déan Token Láimhe',
            reGenerateHandshakeToken: 'Athghineadh Token Láimhe',
            changeMutualOCPIVersion: 'Athraigh Leagan OCPI Comhpháirte',
            handshakeDetails: 'Sonraí Láimhe',
        },
        message: {
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage:
                'Díshábháil an CPO seo cuirfear stop le gach cumarsáid OCPI, cuirfear láithreacha luchtaithe gaolmhara i bhfolach ó fheidhmchláir, marcálfar stáisiúin luchtaithe nasctha mar "Bainte" agus bainfear láithreacha as grúpaí rochtana. An bhfuil tú cinnte gur mian leat leanúint ar aghaidh?',
        },
        insert: {
            header: 'Bainistigh Oibreoir Pointe Luchtaithe',
            placeholder: {
                name: 'Ainm',
                party_id: 'Aitheantas an Pháirtí',
                country_code: 'Cód Tíre',
                ocpi: 'EMSP',
                version_url: 'Leagan URL an CPO',
                token_a: 'Comhartha A',
                token_b: 'Comhartha B',
                token_c: 'Comhartha C',
                colour_code: 'Cód Dathanna',
                back_office_url: 'URL Cúloifige',
                vat_type: 'Cineál CBL',
                region: 'Roghnaigh Réigiún',
                vat: 'Roghnaigh CBL',
                cpo_type: 'Cineál CPO',
            },
            label: {
                name: 'Ainm',
                party_id: 'Aitheantas an Pháirtí',
                country_code: 'Cód Tíre',
                ocpi: 'EMSP',
                version_url: 'URL an leagan',
                token_a: 'Comhartha A',
                token_b: 'Comhartha B',
                token_c: 'Comhartha C',
                locationGroup: 'Suíomh Grúpa',
                rfidDriverTokens: 'Comhroinn ach comharthaí tiománaithe RFID',
                colour_code: 'Cód Dathanna',
                back_office_url: 'URL Cúloifige',
                vat_type: 'Cineál CBL',
                disableLocationPatchPutRemovals: 'Díchumasaigh baint PATCH/PUT Location',
                enableAutoMaxPowerCalculation: 'Cumasaigh ríomh cumhachta uasta uathoibríoch',
                mutual_ocpi_version: 'Leagan OCPI Frithpháirteach',
                externalCPO: 'Réigiún Gaolmhar',
                is_external: '##COMPANY_BRAND_NAME## OCÉ Idirnáisiúnta',
                defaultVat: 'CBL réamhshocraithe (Sáraigh)',
                gmbAccountID: 'Aitheantas Cuntais GMB',
                cpo_type: 'Cineál CPO',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm bailí OCÉ',
                },
                party_id: {
                    valid: 'Cuir isteach Aitheantas Comhpháirtí bailí',
                },
                country_code: {
                    valid: 'Cuir isteach Cód Tíre bailí',
                },
                version_url: {
                    url: 'Caithfidh URL an leagain a bheith ina URL bailí',
                },
                colour_code: {
                    valid: 'Cuir isteach Cód Dathanna bailí',
                },
                back_office_url: {
                    url: 'Caithfidh URL na Cúloifige a bheith ina URL bailí',
                },
            },
        },
        versionEndpoints: {
            header: 'Críochphointí Leagan',
            label: {
                version: 'Leagan',
                identifier: 'Aitheantóir',
                role: 'Ról',
                url: 'URL',
                last_executed: 'An Sioncronú Deiridh a Cuireadh i bhFeidhm',
            },
        },
        modal: {
            message:
                'Tá tú ag marcáil an OCÉ seo mar ##COMPANY_BRAND_NAME## CPO idirnáisiúnta, ní mór duit na suíomhanna OCÉ seo a chur leis de láimh sa ghrúpa rochtana poiblí',
            okButton: 'ceart go leor',
        },
        performHandshakeModal: {
            handshakeHeader: 'Déan Láimhe',
            reHandshakeHeader: 'Déan Láimhe arís',
            label: {
                mutual_ocpi_version: 'Leagan Comhpháirte OCPI',
                version_url: 'URL Leagan',
                handshake_token: 'Token Láimhe',
            },
            placeholder: {
                mutual_ocpi_version: 'Leagan Comhpháirte OCPI',
                version_url: 'URL Leagan',
                handshake_token: 'Token Láimhe',
            },
            button: {
                cancel: 'Cealaigh',
                generateHandshakeToken: 'Déan Token Láimhe',
                confirm: 'Dearbhaigh',
                connect: 'Ceangal',
                reconnect: 'Athcheangail',
            },
            confirmationModal: {
                header: 'Déan Láimhe',
                rehandshakeMessage:
                    'Déanfar creidhmheasa CPO a athrú tar éis láimhe arís. An bhfuil tú cinnte gur mhaith leat leanúint leis an láimhe arís?',
                tokenGeneratedMessage:
                    "Tá an token láimhe don CPO cheana féin gineadh. Má thugtar an token don CPO agus má thráchtann an CPO láimhe a dhéanamh leis an EMSP, d'fhéadfadh sé a mhainneachtain. An bhfuil tú cinnte gur mhaith leat leanúint leis an láimhe arís?",
            },
            cpoAuthTokenMessage: 'Is é an luach réamhshocraithe a thaispeántar anseo ná CPO Auth Token',
        },
        generateHandshakeTokenModal: {
            header: 'Déan Token Láimhe',
            reGenerateTokenHeader: 'Athghin Token Láimhe',
            label: {
                handshakeToken: 'Token Láimhe',
                emsp_auth_token: 'Token Údarú EMSP',
                emspVersionURL: 'URL Leagan EMSP',
            },
            Placeholder: {
                handshakeToken: 'Token Láimhe',
                emsp_auth_token: 'Token Údarú EMSP',
            },
            button: {
                save: 'Sábhail',
                copyToClipboard: 'Cóipeáil chuig Clár Gearra',
                generateToken: 'Gintear',
                reGenerateToken: 'Athghin',
                confirm: 'Dearbhaigh',
                cancel: 'Cealaigh',
            },
            copyToClipboard: {
                success: 'Cóipeáladh an token chuig clár gearra',
                failed: 'Mearúlacht ag cóipeáil an token',
            },
            confirmationModal: {
                confirmationMessage:
                    "Má thugtar an sean token láimhe don CPO, d'fhéadfadh sé a mhainneachtain má thráchtann an CPO é a úsáid don láimhe. An bhfuil tú cinnte gur mhaith leat an token nua a shábháil?",
                header: 'Sábhail Token',
            },
            emspAuthTokenMessage: 'Is é an luach réamhshocraithe a thaispeántar anseo ná EMSP Auth Token',
        },
        changeMutualOCPIVersionModal: {
            header: 'Athraigh Leagan Comhpháirte OCPI',
            label: {
                mutualOCPIVersion: 'Leagan Comhpháirte OCPI',
            },
            button: {
                save: 'Sábhail',
                cancel: 'Cealaigh',
                confirm: 'Dearbhaigh',
            },
            confirmationModal: {
                confirmationMessage: 'An bhfuil tú cinnte gur mhaith leat Leagan Comhpháirte OCPI a leasú?',
            },
        },
        handshakeDetailsModal: {
            header: 'Sonraí Láimhe',
            label: {
                version_url: 'URL Leagan',
                handshakeToken: 'Token Láimhe',
                emspAuthToken: 'Token Údarú EMSP',
                cpoAuthToken: 'Token Údarú CPO',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Aistrithe Inmheánacha : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Aistrithe Inmheánacha',
        transferDetailTitle: 'Sonraí Aistrithe : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        transferDetailHeader: 'Sonraí Aistrithe',
        label: {
            transfer_id: 'Aitheantas aistrithe',
            gross_value: 'Luach Comhlán',
            created_date: 'Dáta Cruthaithe',
            action: 'Gníomh',
            transferNumber: 'Uimhir Aistrithe',
            transferDate: 'Dáta Aistrithe',
            transaction: 'ID Idirbhirt',
            transactionStartDate: 'Dáta Tosaigh an Idirbhirt',
            transactionEndDate: 'Dáta Deiridh an Idirbhirt',
            publicCardId: 'Aitheantas Cárta Poiblí',
            driverAccountId: 'Aitheantas cuntais tiománaí',
            driverName: 'Tiománaí/Feithicil Uimh.',
            stationId: 'Aitheantas an stáisiúin',
            stationName: 'Ainm an Stáisiúin',
            stationAddress: 'Seoladh an Stáisiúin',
            kwh: 'kWh',
            price_per_kwh: 'Praghas/kWh',
            disable: 'FAOI MHÍCHUMAS',
        },
        placeholder: {
            start_date: 'Dáta tosaigh',
            end_date: 'Dáta deiridh',
            status: 'Stádas',
            cpo: 'Roghnaigh CPO',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            action: 'Gníomh',
        },
        errors: {
            cpo: {
                required: 'Roghnaigh CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Soláthraithe Seirbhíse Íocaíochta: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Soláthraithe Seirbhíse Íocaíochta',
        placeholder: {
            name: 'Ainm',
            status: 'Roghnaigh Stádas',
            type: 'Roghnaigh Cineál',
        },
        label: {
            name: 'Ainm',
            code: 'Cód',
            type: 'Cineál',
            description: 'Cur síos',
            store_name: 'Stóráil',
            department_name: 'Roinn',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            details: 'Sonraí',
            key: 'eochair',
            value: 'Luach',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            add: 'Cuir',
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            getCredentials: 'Faigh Dintiúir',
            delete: 'Scrios',
        },
        message: {
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        insert: {
            header: 'Bainistigh Soláthraí Seirbhíse Íocaíochta',
            placeholder: {
                name: 'Ainm',
                type: 'Cineál',
                description: 'Cur síos',
                store_name: 'Ainm an Stórais',
                store_id: 'Aitheantas an tStórais',
                merchant_name: 'Ainm an Cheannaí',
                merchant_id: 'Aitheantas Ceannaí',
                department_name: 'Ainm na Roinne',
                department_id: 'Aitheantas na Roinne',
                signature_key: 'Eochair Sínithe',
                secret_key: 'Eochair Rúnda',
                user_name: 'Ainm Úsáideora',
                password: 'Pasfhocal',
                data: 'Sonraí',
                category: 'Catagóir',
                url: 'URL',
                acquirerId: 'Aitheantas an Fhaighteora',
                firstName: 'Ainm',
                lastName: 'Sloinne',
                houseName: 'Ainm Tí',
                postcode: 'Cód Poist',
                donationProviderType: 'Cineál Povider Síntiúis',
                isGiftAid: 'Is Gift Aid',
                donationStoreId: 'Aitheantas Stórais Síntiús',
                donationMerchantNumber: 'Uimhir Cheannaí Síntiúis',
                clientID: 'Aitheantas Cliant',
                clientSecret: 'Rúnda Cliant',
                terminalID: 'Aitheantas Teirminéil',
                enableCardRefunds: 'Cumasaigh Aisíocaíochtaí Cárta',
                enableCardVerification: 'Cumasaigh Fíorú Cárta',
                enableCharity: 'Cumasaigh carthanacht',
            },
            label: {
                name: 'Ainm',
                type: 'Cineál',
                firstName: 'Ainm',
                lastName: 'Sloinne',
                houseName: 'Ainm Tí',
                postcode: 'Cód Poist',
                donationProviderType: 'Cineál Povider Síntiúis',
                isGiftAid: 'Is Gift Aid',
                donationStoreId: 'Aitheantas Stórais Síntiús',
                donationMerchantNumber: 'Uimhir Cheannaí Síntiúis',
                code: 'Cód',
                description: 'Cur síos',
                store_name: 'Ainm an Stórais',
                store_id: 'Aitheantas an tStórais',
                merchant_name: 'Ainm an Cheannaí',
                merchant_id: 'Aitheantas Ceannaí',
                department_name: 'Ainm na Roinne',
                department_id: 'Aitheantas na Roinne',
                signature_key: 'Eochair Sínithe',
                secret_key: 'Eochair Rúnda',
                user_name: 'Ainm Úsáideora',
                password: 'Pasfhocal',
                data: 'Sonraí',
                action_urls: 'URLanna gníomhaíochta',
                category: 'Catagóir',
                url: 'URL',
                acquirerId: 'Aitheantas an Fhaighteora',
                clientID: 'Aitheantas Cliant',
                clientSecret: 'Rúnda Cliant',
                terminalID: 'Aitheantas Teirminéil',
                enableCardRefunds: 'Cumasaigh Aisíocaíochtaí Cárta',
                enableCardVerification: 'Cumasaigh Fíorú Cárta',
                enableCharity: 'Cumasaigh carthanacht',
                mobileMerchantId: 'Aitheantas Ceannaí Soghluaiste',
                mobileMerchantPassword: 'Pasfhocal Ceannaí Soghluaiste',
                enableIncrementalAuthorizations: 'Cumasaigh Údaruithe Incriminteacha',
                excludedCardsForIncrementalAuthorizations: 'Cártaí eisiata le haghaidh údaruithe incriminteacha',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm bailí',
                },
                code: {
                    valid: 'Cuir isteach Cód bailí',
                },
                url: {
                    valid: 'Caithfidh URL a bheith ina URL bailí',
                },
                DatatransSupportCards: {
                    valid: 'Cuir isteach luach bailí le haghaidh DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'Cártaí RFID: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Cártaí RFID',
        placeholder: {
            name: 'Ainm an Tiomána / Ríomhphost / Eagraíocht',
            manufacturer: 'Monaróir',
            part_id: 'Cuid Id',
            public_card_id: 'Aitheantas Cárta Poiblí',
            status: 'Roghnaigh Stádas',
            mifare_uid: 'AitheantasÚsáideora Mifare',
        },
        label: {
            name: 'Leithdháilte ar',
            email_vehicle: 'Cuntas Gaolmhar',
            manufacturer: 'Monaróir',
            part_id: 'Cuid Id',
            public_card_id: 'Aitheantas Cárta Poiblí',
            private_card_id: 'Aitheantas Cárta Príobháideach',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            delete: 'Scrios',
            deAllocate: 'Bain Cumann',
            view: 'Féach ar Sonraigh',
            allocateCardToOrganisation: 'Tabhair mórchártaí don Eagraíocht',
            mifare_uid: 'MIFARE AitheantasÚsáideora',
            reinstate: 'Athchuir Cárta',
            card_type: 'Cineál Cárta',
            removeBulkAssociation: 'Bain Cumann Cártaí RFID i Bulc',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            add: 'Cuir',
            addBulk: 'Cuir mórchártaí le monarú',
            assing: 'Cártaí RFID a shannadh',
            allocateRFIDCard: 'Leithdháil Cárta RFID',
            import: 'Iompórtáil Comhad Déantúsaíochta',
            export: 'Comhad Déantúsaíochta Easpórtála',
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            getCredentials: 'Faigh Dintiúir',
            delete: 'Scrios',
            deAllocate: 'Bain Cumann',
            view: 'Féach ar Sonraigh',
            reinstate: 'Athchuir Cárta',
            forceCPOUpdate: 'Cuir i bhFeidhm Nuashonrú CPO',
        },
        errors: {
            export: {
                notSeletedCards: 'Roghnaigh cártaí ag Feitheamh le hEaspórtáil',
            },
        },
        message: {
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            deAllocateConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat Cumann Cártaí RFID a bhaint de Chuntas?',
            reinstateConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat an Cárta RFID a chur ar ais?',
            forceCPOUpdateConfirmMessage:
                'An bhfuil tú cinnte gur mhaith leat an comhartha nuashonraithe a chur i bhfeidhm sa chóras OCÉ?',
        },
        insert: {
            header: 'Bainistigh cártaí RFID',
            placeholder: {
                manufacturer: 'Ainm Monaróra',
                part_id: 'Cuid Id',
                public_card_id: 'Aitheantas cárta poiblí',
                private_card_id: 'Aitheantas Cárta Príobháideach',
                mifare_uid: 'AitheantasÚsáideora Mifare',
                card_type: 'Cineál Cárta',
            },
            label: {
                manufacturer: 'Monaróir',
                part_id: 'Cuid Id',
                public_card_id: 'Aitheantas cárta poiblí',
                private_card_id: 'Aitheantas Cárta Príobháideach',
                mifare_uid: 'AitheantasÚsáideora Mifare',
                card_type: 'Cineál Cárta',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm bailí',
                },
                code: {
                    valid: 'Cuir isteach Cód bailí',
                },
                url: {
                    valid: 'Caithfidh URL a bheith ina URL bailí',
                },
            },
        },
        bulkCards: {
            header: 'Cuir Mórchártaí leis',
            placeholder: {
                manufacturer: 'Ainm Monaróra',
                part_id: 'Cuid Id',
                no_of_cards: '100 Cárta',
                cardType: 'Roghnaigh Cineál Cárta',
            },
            label: {
                manufacturer: 'Ainm Monaróra',
                part_id: 'Cuid Id',
                no_of_cards: 'Líon na gCártaí',
                cardType: 'Cineál Cárta',
            },
            button: {
                yes: 'Cruthaigh Cártaí',
                no: 'Cealaigh',
            },
            errors: {
                no_of_cards: {
                    min: 'Ní féidir le líon na gCártaí a bheith níos lú ná 1',
                },
            },
        },
        assignCards: {
            header: 'Cártaí RFID a shannadh',
            header2: 'Tá X cártaí roghnaithe agat.',
            selectedCard: 'Tá 1 chárta roghnaithe agat.',
            placeholder: {
                manufacturer: 'Ainm Monaróra',
                part_id: 'Cuid Id',
                no_of_cards: '100 Cárta',
            },
            label: {
                driver: 'Tiománaí',
                organisation: 'Eagraíocht',
                no_of_cards: 'Líon na gCártaí',
            },
            button: {
                yes: 'Sann',
                no: 'Cealaigh',
            },
            form: {
                type: {
                    driver: 'Tiománaí',
                    organisation: 'Eagraíocht',
                },
                driver: 'Tiománaí',
                organisation: 'Eagraíocht',
                placeholder: {
                    driver: 'Roghnaigh Tiománaí',
                    organisation: 'Roghnaigh Eagraíocht',
                },
            },
            errors: {
                notSeletedCards: 'Roghnaigh na cártaí atá ar fáil',
            },
        },
        disableCards: {
            header: 'Díchumasaigh',
            header2: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            placeholder: {
                comment: 'Cuir isteach trácht',
            },
            label: {
                comment: 'Trácht',
            },
            button: {
                yes: 'Tá',
                no: 'Níl',
            },
        },
        allocateCards: {
            header: 'Cártaí RFID a leithdháileadh',
            placeholder: {
                file: 'Roghnaigh comhad CSV',
                selectOrganisation: 'Roghnaigh Eagraíocht',
            },
            label: {
                file: 'Comhad CSV',
                organisation: 'Eagraíocht',
                mifareUID: 'AitheantasÚsáideora Mifare',
                publicCardID: 'Aitheantas Cárta Poiblí',
                clickHere: 'Cliceáil anseo',
                downloadTemplate: 'chun teimpléad a íoslódáil',
            },
            button: {
                allocate: 'Leithdháil',
                cancel: 'Cealaigh',
            },
            errors: {
                file: {
                    fileType: "Is féidir comhad leis an síneadh '.csv' a uaslódáil.",
                },
            },
        },
        removeAssociation: {
            header: 'Bain Cumann Cártaí RFID i Bulc',
            placeholder: {
                file: 'Roghnaigh comhad CSV',
            },
            label: {
                file: 'Comhad CSV',
                clickHere: 'Cliceáil anseo',
                downloadTemplate: 'chun teimpléad a íoslódáil',
            },
            button: {
                save: 'Sábháil',
                cancel: 'Cealaigh',
            },
            errors: {
                file: {
                    fileType: "Is féidir comhad leis an síneadh '.csv' a uaslódáil.",
                },
                maxRFIDRecordsReached:
                    'Shroich do chomhad CSV uaslódáilte an t-uaslíon de 10,000 taifead aitheantais cárta poiblí cárta RFID, le do thoil laghdaigh taifid aitheantais chárta poiblí cártaí RFID ar an gcomhad csv.',
            },
        },
        importCards: {
            header: 'Iompórtáil Cártaí RFID',
            placeholder: {
                file: 'Roghnaigh comhad CSV',
            },
            label: {
                file: 'Comhad CSV',
            },
            button: {
                yes: 'Iompórtáil',
                no: 'Cealaigh',
            },
            errors: {
                file: {
                    fileType: "Is féidir comhad leis an síneadh '.csv' a uaslódáil.",
                },
            },
        },
        importCardsDetails: {
            header: 'Sonraí Iompórtála Cártaí RFID',
            label: {
                unSuccessfullImport: 'Ní féidir na cártaí seo a leanas a iompórtáil',
                successfullImport: 'D’éirigh le hiompórtáil na gcártaí seo a leanas',
                failerReason: 'Cúis teipe',
                publicCardId: 'ID Cárta Poiblí',
            },
            message: {
                defualtErrorMessage: 'Tá fadhb ann leis na cártaí seo a iompórtáil.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Dáta Imeachta',
                chargeLocation: 'Suíomh Táille',
                charge_station_name: 'Ainm an Stáisiúin',
                response_status: 'Stádas Freagartha',
            },
        },
    },
    referralPromotion: {
        title: 'Cur Chun Cinn Atreoraithe: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Arduithe Céime Atreoraithe',
        manageReferralPromotion: 'Bainistigh Cur Chun Cinn Atreoraithe',
        label: {
            name: 'Ainm',
            code: 'Cód',
            minCharge: 'Min. ',
            maxLimit: 'uas. ',
            maxRefreeLimit: 'uas. ',
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            disabled: 'Faoi mhíchumas',
            enabled: 'Cumasaithe',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            promotionCode: 'Cód Cur Chun Cinn',
            description: 'Cur síos',
            maxReferralLimit: 'Uasteorainn Atreoraithe',
            minChargeValue: 'Luach Íosmhuirir',
            refereeBonus: 'Bónas Réiteoir',
            referrerBonus: 'Bónas Tarchuir',
        },
        button: {
            search: 'Cuardach',
            back: 'Ar ais',
            add: 'Cuir',
            reset: 'Athshocraigh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            action: 'Gníomh',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        placeholder: {
            name: 'Ainm',
            code: 'Cód',
            selectPromotion: 'Roghnaigh Cur Chun Cinn',
            selectStatus: 'Roghnaigh Stádas',
            promotionCode: 'Cód Cur Chun Cinn',
            description: 'Cur síos',
            maxReferralLimit: 'Uasteorainn Atreoraithe',
            minChargeValue: 'Luach Íosmhuirir',
            refereeBonus: 'Bónas Réiteoir',
            referrerBonus: 'Bónas Tarchuir',
        },
        errors: {
            name: {
                valid: 'Cuir isteach ainm promóisin bailí',
            },
            promotionCode: {
                valid: 'Cuir isteach cód promóisin bailí',
            },
            maxReferralLimit: {
                moreThan: 'Caithfidh uasteorainn atreoraithe a bheith níos mó ná nialas',
            },
            referrerBonus: {
                max: 'Ní féidir luach an Bhónais Tagra a bheith níos mó ná ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'Ní féidir luach an Bhónais Tagartha a bheith níos mó ná ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Téarmaí ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Téarmaí',
        manageTermsConditions: 'Bainistigh Téarmaí',
        label: {
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            name: 'Ainm',
            description: 'Cur síos',
            apply_to: 'Déan Iarratas Chun',
            mandatory_for_user: 'Éigeantach don Úsáideoir',
            status: 'Stádas',
            delete: 'Scrios',
            content: 'Ábhar Beartais',
            yes: 'Tá',
            no: 'Níl',
            draft: 'Dréacht',
            published: 'Foilsithe',
        },
        placeholder: {
            name: 'Ainm',
            description: 'Cur síos',
            select: {
                apply_to: 'Déan Iarratas Chun',
                status: 'Roghnaigh Stádas',
            },
        },
        columns: {
            name: 'Ainm',
            description: 'Cur síos',
            applyto: 'Déan Iarratas Chun',
            mandatory_for_user: 'Éigeantach',
            status: 'Stádas',
            action: 'Gníomh',
            modified_date: 'Athraithe Ar',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            add: 'Cuir',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
        },
        errors: {
            name: {
                valid: 'Cuir isteach ainm bailí',
            },
            invalidFormat: 'Uaslódáil formáid íomhá bhailí',
            common: 'Tharla earráid, bain triail eile as.',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
        },
    },
    rewardPromotion: {
        title: 'Arduithe Céime: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'IV Arduithe Céime',
        manageRewardPromotion: 'Bainistigh IV Cur Chun Cinn Luaíochta',
        label: {
            name: 'Ainm',
            code: 'Cód',
            valuesPerkwh: 'Luachanna in aghaidh an kWh',
            monetoryValue: 'Luach airgeadaíochta',
            redemptionBlock: 'Bloc Fuascailte',
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            action: 'Gníomh',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            promotionCode: 'Cód Cur Chun Cinn',
            description: 'Cur síos',
            expired: 'imithe in éag',
            locationApplicable: 'Suíomh Táille Infheidhmithe',
            voltsPerkwh: 'Volta in aghaidh an kWh',
            confirmation: 'Daingniú',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            delete: 'Scrios',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            uncheckConfirmMesage:
                'Nuair a bheidh an ticbhosca seo á dhíthiceáil, bainfear gach suíomh muirir a bhaineann leis an promóisean seo. ',
        },
        placeholder: {
            name: 'Ainm',
            code: 'Cód',
            selectPromotion: 'Roghnaigh cur chun cinn',
            selectStatus: 'Roghnaigh Stádas',
            locationApplicable: 'Suíomh Táille Infheidhmithe',
            voltsPerkwh: 'Volta in aghaidh an kWh',
        },
        errors: {
            name: {
                valid: 'Cuir isteach ainm promóisin bailí',
            },
            promotionCode: {
                valid: 'Cuir isteach cód promóisin bailí',
            },
            monetoryValue: {
                moreThan: 'Caithfidh luach airgeadaíochta a bheith níos mó ná nialas',
                lessThan: 'Caithfidh luach airgeadaíochta a bheith níos lú ná nó cothrom le 99999.99',
                typeError: 'Cuir isteach luach airgid bailí',
            },
            redemptionPointBlock: {
                moreThan: 'Caithfidh Bloc Fuascailte a bheith níos mó ná nialas',
            },
            valuePerKwh: {
                moreThan: 'Caithfidh luach a bheith níos mó ná nialas',
            },
        },
    },
    amenitys: {
        title: 'Áiseanna: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Áiseanna',
        manageamenitys: 'Taitneamhachtaí a bhainistiú',
        chargeStationsList: 'Stáisiúin Táille',
        chargeLocation: 'Suímh Muirir',
        amenityTranslationNote:
            'Cuir isteach sonraí taitneamhachta úsáideoirí/tiománaithe riaracháin i dteanga an réigiúin faoi seach. ',
        label: {
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            name: 'Ainm',
            imageUpload: 'Deilbhín (34X 34)',
            language: 'Teanga',
            image: 'Deilbhín',
            description: 'Cur síos',
            default_search: 'Cuardach Réamhshocraithe',
            status: 'Stádas',
            delete: 'Scrios',
            csvFile: 'Comhad CSV',
            importAmenityHeader: 'Áiseanna Iompórtála',
            chargeLocation: {
                name: 'Ainm',
                type: 'Cineál',
                address: 'Seoladh',
                city: 'Cathair',
                postal_code: 'Cód Poist',
                modifiedDate: 'Dáta Athraithe',
                action: 'Gníomh',
            },
            charge_station_name: 'Muirear_Stáisiún_Ainm',
            charge_point: 'Muirear_Pointe',
            charge_location_name: 'Muirear_Suíomh_Ainm',
            latitude: 'Domhanleithead',
            longitude: 'Domhanfhad',
            location_address: 'Suíomh_Seoladh',
            amenities: 'Áiseanna',
            amenity_type: 'Cineál Taitneamhachta',
        },
        placeholder: {
            name: 'Ainm',
            description: 'Cur síos',
            file: 'Roghnaigh comhad CSV',
            select: {
                status: 'Roghnaigh Stádas',
                amenity_type: 'Roghnaigh Cineál',
            },
        },
        columns: {
            name: 'Ainm',
            description: 'Cur síos',
            status: 'Stádas',
            action: 'Gníomh',
            amenity_type: 'Cineál',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            add: 'Cuir',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            disable: 'Díchumasaigh',
            enable: 'Cumasaigh',
            import: 'Iompórtáil',
        },
        errors: {
            common: 'Tharla earráid, bain triail eile as.',
            name: {
                valid: 'Cuir isteach ainm bailí.',
            },
            image: {
                fileType: "Is féidir comhad le síneadh '.jpg', '.png', '.svg', '.jpeg' a uaslódáil.",
                dimensions: 'Caithfidh an deilbhín a bheith 34 X 34 toise',
                required: 'Is réimse riachtanach é icon',
            },
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
    },
    vehicle: {
        title: 'Feithicil: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Feithiclí',
        columns: {
            name: 'Ainm',
            registerNo: 'Clár Uimh',
            make: 'Déan',
            model: 'Mionsamhail',
            chargeType: 'Cineál Muirear',
            batteryCapacity: 'Cumas Battery',
            consumption: 'Caitheamh',
        },
        placeholder: {
            nameEmail: 'Ainm / Ríomhphost',
            makeModelRegistrationNo: 'Déan / Múnla / Clár Uimh',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
        },
    },
    incompleteSessions: {
        title: 'Seisiúin Neamhiomlána: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Seisiúin Neamhiomlána',
        placeholder: {
            nameOrEmail: 'Ainm / Ríomhphost',
            locationOrStation: 'Suíomh / Stáisiún',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            status: 'Roghnaigh Stádas',
            comment: 'Cuir isteach do chuid tuairimí',
        },
        label: {
            invalid: 'Neamhbhailí',
            generateCDR: 'Gin CDR',
            totalEnergy: 'Fuinneamh Iomlán',
            totalCost: 'Costas Iomlán',
            comment: 'Cuir isteach do chuid tuairimí',
            cancelCDR: 'Cealaigh CDR',
        },
        columns: {
            name: 'Ainm',
            location: 'Suíomh',
            sessionId: 'Aitheantas an tSeisiúin',
            startDate: 'Dáta tosaigh',
            modifiedDate: 'Dáta Athraithe',
            time: 'Am',
            energy: 'Fuinneamh </br> (kWh)',
            cost: 'Costas',
            status: 'Stádas',
            action: 'Gníomh',
        },
        button: {
            action: 'Gníomh',
            generateCDR: 'Gin CDR',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            yes: 'Tá',
            no: 'Níl',
            cancelCDR: 'Cealaigh CDR',
        },
        error: {
            max: '250 carachtar ar a mhéad a cheadaítear',
        },
        message: {
            cancelCDRMessage: 'An bhfuil tú cinnte gur mhaith leat an seisiún a chur ar ceal?',
            cancelBulkCDRMessage:
                'An bhfuil tú cinnte gur mhaith leat seisiún a chur ar ceal le haghaidh taifead roghnaithe?',
            selectCDR: 'Roghnaigh seisiúin neamhchríochnaithe le do thoil',
        },
    },
    ocpiSessions: {
        title: 'Seisiúin OCPI: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Seisiúin',
        placeholder: {
            nameOrEmail: 'Ainm / Ríomhphost',
            locationOrStation: 'Suíomh / Stáisiún',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            status: 'Roghnaigh Stádas',
            comment: 'Cuir isteach do thuairimí',
        },
        columns: {
            name: 'Ainm',
            location: 'Suíomh',
            sessionId: 'Aitheantas an tSeisiúin',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            time: 'Am',
            energy: 'Fuinneamh </br> (kWh)',
            cost: 'Costas',
            status: 'Stádas',
            action: 'Gníomh',
            vehicleNumber: 'Uimhir Feithicle',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            complete: 'Críochnaigh',
        },
        label: {
            complete: 'Críochnaigh',
            completeSessions: 'Críochnaigh Seisiúin Muirearú',
        },
        message: {
            completeConfirmMessage: 'Ar mhaith leat an seisiún luchtaithe a chríochnú?',
            stopBulkSessionsMessage: 'Ar mhaith leat seisiúin luchtaithe roghnaithe a chríochnú?',
            selectSession: 'Roghnaigh Seisiúin Luchtaithe le do thoil',
        },
    },
    organisation: {
        title: 'Bainistigh Eagraíocht: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Eagraíocht',
        manageOrganisation: 'Eagraíocht a bhainistiú',
        label: {
            name: 'Ainm',
            description: 'Cur síos',
            address: 'Seoladh',
            city: 'Cathair',
            county: 'Contae',
            postal_code: 'Cód Poist',
            contact_person: 'Duine Teagmhála',
            email: 'Ríomhphost',
            phone_number: 'Fón Uimh',
            payment_mode: 'Mód Íocaíochta',
            payment_schedule: 'Sceideal Íocaíochta',
            user_group_ids: 'Grúpaí Úsáideoirí',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            amount: 'Teorainn Chreidmheasa',
            po_number: 'Uimhir PO',
            finance_account_number: 'Uimhir Chuntais Airgeadais',
            account_contact_email: 'Ríomhphost Teagmháil Cuntais',
            remaining_credit: 'Creidmheas fágtha (%)',
            remoteChargePassword: 'Tosaigh Pasfhocal Cianmhuirir',
            is_deleted: 'An bhfuil Scriosta',
            yes: 'Tá',
            deleted: 'Scriosta',
            dailySpendLimit: 'Teorainn Chaiteachais Laethúil',
            weeklySpendLimit: 'Teorainn Chaiteachais Sheachtainiúil',
            monthlySpendLimit: 'Teorainn Caiteachais Mhí Féilire',
            defaultSpendLimitGroup: 'Grúpa Teorainneacha Caiteachais Réamhshocraithe',
            updateSpendLimitAssociation: 'Cumann Grúpa Teorainneacha Caitheamh',
            promotionUpdate: 'Nuashonrú Cur Chun Cinn',
            currentPromotion: 'Cur Chun Cinn Reatha',
            newPromotion: 'Cur Chun Cinn Nua',
        },
        placeholder: {
            name: 'Ainm',
            name_or_email_or_contact_person: 'Ainm/Duine Teagmhála/Ríomhphost',
            description: 'Cur síos',
            address: 'Seoladh',
            city: 'Cathair',
            county: 'Contae',
            postal_code: 'Cód Poist',
            contact_person: 'Duine Teagmhála',
            email: 'Ríomhphost',
            phone_number: 'Fón Uimh',
            select: {
                status: 'Roghnaigh Stádas',
                payment_mode: 'Roghnaigh Mód Íocaíochta',
                payment_schedule: 'Roghnaigh Sceideal Íocaíochta',
                user_group_ids: 'Roghnaigh Grúpaí Úsáideoirí',
            },
            amount: 'Teorainn Chreidmheasa',
            po_number: 'Uimhir PO',
            finance_account_number: 'Uimhir Chuntais Airgeadais',
            remaining_credit: 'Creidmheas fágtha (%)',
            remoteChargePassword: 'Tosaigh Pasfhocal Cianmhuirir',
            enableSpendLimit: 'Cumasaigh Teorainn Caiteachais',
            defaultSpendLimitGroup: 'Roghnaigh Grúpa Teorainneacha Caiteachais Réamhshocraithe',
            selectCurrentPromotion: 'Roghnaigh Cur Chun Cinn Reatha',
            selectNewPromotion: 'Roghnaigh Cur Chun Cinn Nua',
        },
        columns: {
            name: 'Ainm',
            contact_Person: 'Duine Teagmhála',
            email: 'Ríomhphost',
            payment_mode: 'Mód Íocaíochta',
            payment_schedule: 'Sceideal Íocaíochta',
            created_date: 'Cruthaithe Ar',
            status: 'Stádas',
            action: 'Gníomh',
            remote_charge_password: 'Tosaigh Pasfhocal Cianmhuirir',
            promotion: 'cur chun cinn',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            add: 'Cuir',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            permission: 'Cead API',
            assignSpendLimitGroup: 'Sann Grúpa Teorainneacha Caiteachais',
        },
        errors: {
            name: {
                valid: 'Cuir isteach ainm bailí',
            },
            contact_person: {
                valid: 'Cuir isteach teagmhálaí bailí',
            },
            email: {
                required: 'Cuir isteach seoladh ríomhphoist',
                email: 'Cuir isteach seoladh ríomhphoist bailí',
            },
            phoneNo: {
                required: 'Cuir isteach uimhir theileafóin le do thoil',
                match: 'Cuir isteach uimhir theileafóin bhailí',
            },
            amount: {
                moreThan: 'Caithfidh an méid a bheith níos mó ná 0',
                maxcredit: 'Uasteorainn bainte amach le haghaidh creidmheasa cuntais',
            },
            po_number: {
                valid: 'Cuir isteach uimhir PO bailí',
            },
            finance_account_number: {
                valid: 'Cuir isteach uimhir chuntais airgeadais bhailí',
            },
            account_contact_email: {
                required: 'Cuir isteach seoladh ríomhphoist amháin ar a laghad',
                maxLimit: 'Uasteorainn bainte amach le haghaidh ríomhphost teagmhála cuntais',
            },
            remaining_credit: {
                match: 'Cuir isteach creidmheas bailí atá fágtha',
                maxCredit: 'Níor cheart go sáródh uasluach an chreidmheasa atá fágtha 100',
                minCredit: 'Níor cheart go mbeadh an t-íosluach creidmheasa atá fágtha níos lú ná 0',
            },
            value: {
                moreThan: 'Caithfidh luach a bheith níos mó ná 0',
                lessThan: 'Caithfidh luach a bheith níos lú ná nó cothrom le 5000',
                number: 'Caithfidh luach a bheith ina uimhir',
                lessThanWeekly:
                    'Caithfidh an luach a bheith níos lú ná nó cothrom leis an teorainn chaiteachais sheachtainiúil',
                lessThanMonthly:
                    'Caithfidh an luach a bheith níos lú ná nó cothrom leis an teorainn chaiteachais mhíosúil',
            },
            spend_limit: {
                moreThan:
                    'Caithfidh an teorainn chaiteachais sheachtainiúil a bheith níos mó ná an teorainn chaiteachais laethúil',
                lessThan:
                    'Ní mór an teorainn chaiteachais laethúil a bheith níos lú ná an teorainn chaiteachais sheachtainiúil',
            },
            address: 'tá 10 gcarachtar ar a laghad ag teastáil',
            addressValid: 'Cuir isteach an seoladh bailí',
            user_group: {
                required: 'Roghnaigh grúpa úsáideoirí amháin ar a laghad',
            },
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            assignAllDriversToDefaultGroup:
                'Ar mhaith leat tiománaithe uile na heagraíochta seo a shannadh do ghrúpa teorainneacha caiteachais réamhshocraithe?',
            updatePromotionConfirmMessage:
                'An bhfuil tú cinnte gur mhaith leat promóisean a nuashonrú le haghaidh eagraíochtaí roghnaithe?',
            selectOneRecord: 'Roghnaigh eagraíocht amháin ar a laghad le haghaidh nuashonrú ar chur chun cinn',
            promotionAssignMessage: 'Sannfar ardú céime nua do na heagraíochtaí seo a leanas:',
        },
        permission: {
            header: 'Cead API',
            label: {
                description: 'Cur síos',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Logchomhaid Idirbheart: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Logchomhaid Idirbheart',
        placeholder: {
            page: 'Roghnaigh Leathanach',
            email: 'Seoladh ríomhphoist',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            fieldName: 'Ainm an Réimse',
            content: 'Ábhar',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
        },
        label: {
            tableName: 'Ainm an Tábla',
            fieldName: 'Ainm an Réimse',
            oldValue: 'Sean-luach',
            newValue: 'Luach Nua',
            user: 'Úsáideoir',
            logDate: 'Dáta Logála',
            action: 'Gníomh',
            goToPage: 'Téigh go Leathanach',
        },
    },
    organisationAccountBalance: {
        title: 'Iarmhéid Cuntas Eagraíochta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Iarmhéid Cuntas Eagraíochta',
        manageUser: 'Bainistigh Iarmhéid Cuntas Eagraíochta',
        columns: {
            currentBalance: 'Iarmheid reatha',
            closingBalance: 'Iarmhéid Deiridh',
            availableCredit: 'Creidmheas ar Fáil',
            unbilledAmount: 'Méid Neamhbhilleáilte',
            name: 'Ainm',
            contact_Person: 'Duine Teagmhála',
            email: 'Ríomhphost',
            payment_mode: 'Mód Íocaíochta',
            payment_schedule: 'Sceideal Íocaíochta',
            balance: 'Iarmhéid',
            status: 'Stádas',
            action: 'Gníomh',
            refund: 'Leasaigh iarmhéid an chuntais',
        },
        placeholder: {
            name: 'Ainm/Duine Teagmhála/Ríomhphost',
            description: 'Trácht',
            amount: 'Cuir isteach an Méid ar Chreidmheas/Dochar',
            select: {
                status: 'Roghnaigh Stádas',
                payment_mode: 'Mód Íocaíochta',
                payment_schedule: 'Sceideal Íocaíochta',
            },
            invoice: 'Roghnaigh Sonrasc',
        },
        label: {
            description: 'Trácht',
            amount: 'Cuir isteach an Méid ar Chreidmheas/Dochar',
            payment_settlement: 'Leasú Iarmhéid - Iarratas',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            invoice: 'Sonrasc',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            save: 'Sábháil',
            add: 'Cuir',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            action: 'Gníomh',
            send_for_approval: 'Seol le haghaidh Formheasa',
            accept: 'Glac',
        },
        errors: {
            amount: {
                moreThan: 'Caithfidh an méid a bheith níos mó/níos lú ná 0',
                maxcredit: 'Uasteorainn bainte amach le haghaidh creidmheasa cuntais',
                maxdebit: 'Uasteorainn bainte amach do dhochar cuntais',
            },
        },
    },
    driverAward: {
        rewardTitle: 'Iarmhéid Luaíochta - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        approvalRequest: 'Faomhadh Iarmhéid Luaíochta - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        rewards: 'Iarmhéid Luaíocht',
        approvalRequests: 'Faomhadh Iarmhéid Luaíochta',
        label: {
            name: 'Ainm',
            email: 'Ríomhphost',
            iVRewardPromotion: 'IV Cur Chun Cinn Luaíochta',
            balance: 'Iarmhéid',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            location: 'Suíomh',
            date: 'Dáta',
            energy: 'Fuinneamh (kWh)',
            cost: 'Costas',
            rewardPoint: 'Pointe Luaíochta',
            rewardSettelemant: 'Socrú luach saothair',
            description: 'Cur síos',
            credit: 'Creidmheas',
            debit: 'Dochar',
            iVRewardSettelemant: 'Luach saothair - Socrú',
            amount: 'Méid',
            request_by: 'Iarrtha ag',
            request_date: 'Iarrtha Ar',
            review_by: 'Athbhreithnithe ag',
            review_date: 'Athbhreithnithe Ar',
            review_comment: 'Tuairimí an Athbhreithneora',
            approvalRequest: 'Iarratas ar Fhormheas',
            enterComments: 'Cuir isteach do chuid tuairimí',
            transaction_date: 'Dáta Idirbhirt',
            debit_credit: 'Dochar/Creidmheas',
            type: 'Cineál',
            requested_by_comment: 'Iarrtha ag Tuairimí',
            volts: 'Volta',
            commentsFrom: 'Tuairimí Ó',
            approve: 'Cheadaigh',
            decline: 'Meath',
            federatedAccount: 'Cineál Cuntais Cónaidhme',
        },
        placeholder: {
            nameOrEmail: 'Ainm/Ríomhphost',
            selectIVAwardPromotion: 'Roghnaigh IV Gradam Chun Cinn',
            selectStatus: 'Roghnaigh Stádas',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            description: 'Cur síos',
            volts: 'Volta',
            enterComments: 'Cuir isteach do chuid tuairimí',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            decline: 'Meath',
            approve: 'Cheadaigh',
            send_for_approval: 'Seol le haghaidh Formheasa',
        },
        errors: {
            type: {
                required: 'Creidmheas nó Dochar an tsocraíocht',
            },
            volts: {
                typeError: 'Cuir isteach volta bailí',
                moreThan: 'Caithfidh volta a bheith níos mó/níos lú ná 0',
            },
            status: {
                selectApprovalOrReject: 'Ceadaigh/Diúltaigh an t-iarratas seo.',
            },
        },
    },
    organisationdashboard: {
        title: 'Painéal na nEagraíochtaí: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Painéal na hEagraíochta',
        dashboard: 'Deais',
        label: {
            filter: 'Scagaire',
            organisation: 'Eagraíocht',
            selectOrganisations: 'Roghnaigh Eagraíochtaí',
            dateRange: 'Raon Dáta',
            driverGroup: 'Grúpa tiománaí',
            drivers: 'Tiománaí / Feithicil',
            selectDriver: 'Roghnaigh Tiománaí / Feithicil',
            selectDriverGroup: 'Roghnaigh Grúpaí Tiománaithe',
            month: 'Mí',
            year: 'Bliain',
            day: 'Lá',
            week: 'Seachtain',
            userSessionTitle: 'Seisiúin tiománaí',
            userSessions: 'Seisiúin tiománaí',
            totalIncomeTitle: 'Suim Ioncaim',
            income: 'Ioncam',
            energy: 'Fuinneamh',
            energyTitle: 'Suim Fuinnimh (kWh)',
            selectAll: 'Roghnú go léir',
            totalRFIDCards: 'Iomlán Cártaí RFID',
            available: 'Ar fáil',
            allocated: 'Leithdháilte',
            duplicate: 'Dúblach',
            disabled: 'Faoi mhíchumas',
            rfid: 'RFID',
            totalDriverAccounts: 'Iomlán cuntais tiománaithe',
            driver: 'Tiománaithe',
            enabled: 'Cumasaithe',
            pending: 'Ar feitheamh',
            deleted: 'Scriosta',
            topTenDriverVehicles: 'Na 10 dTiománaí/Úsáid Feithicle is Fearr',
            driverAccount: 'Tiománaí',
            vehicle: 'Feithicil',
            driverName: 'Ainm tiománaí',
            vehicleNumber: 'Uimhir Feithicle',
            kwhUsage: 'kWh Úsáid',
            dateRangeLabel: 'Raon Dáta:',
            both: 'An dá',
            nameorvehicleno: 'Ainm/Uimhir na Feithicle.',
            type: 'Cineál',
        },
        button: {
            apply: 'Cuir iarratas isteach',
            clear: 'Glan',
            syncData: 'Sonraí Sioncrónaigh',
            search: 'Cuardach',
            reset: 'Athshocraigh',
        },
    },
    organisationtransactions: {
        headerTitle: 'Idirbhearta Eagraíochta - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        invoiceHeader: 'Sonraí Sonraisc- ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        invoiceTitle: 'Sonrasc Sonraisc',
        title: 'Idirbhearta Eagraíochta',
        transaction: 'Idirbheart',
        columns: {
            location: 'Suíomh',
            date: 'Dáta',
            time: 'Am',
            cost: 'Costas',
            energy: 'Fuinneamh',
            action: 'Gníomh',
            remark: 'Nótaí',
            amount: 'Méid',
            closing: 'Deiridh',
            transaction: 'ID Idirbhirt',
            name: 'Ainm',
            credit: 'Creidmheas',
            debit: 'Dochar',
            vehicleNumber: 'Uimhir Feithicle',
            invoiceNumber: 'Uimhir sonrasc',
            comment: 'Trácht',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
        },
        csvHeader: {
            transaction: 'ID Idirbhirt',
            publicCardId: 'Poiblí_Cárta_ID',
            stationId: 'Aitheantas_stáisiúin',
            transactionStartDate: 'Idirbheart_Tosaithe_Dáta',
            transactionEndDate: 'Idirbheart_Deireadh_Dáta',
            stationAddress: 'Stáisiún_Seoladh',
            driverAccountId: 'Tiománaí_Cuntas_Aitheantas',
            vat_amount: 'CBL_Méid',
            stationName: 'Stáisiún_Ainm',
            kwh: 'kWh_seachadta',
            price_per_kwh: 'Praghas_Per_kWh',
            net_value: 'Glan_Luach',
            vat_rate: 'Ráta_CBL',
            gross_value: 'Comhlán_Luach',
            invoiceNumber: 'Uimhir sonrasc',
            driverName: 'Tiománaí_Ainm',
        },
        form: {
            charge: 'Muirearú',
            payment: 'Íocaíocht',
            month: 'Mí',
        },
        label: {
            exportAll: 'Easpórtáil Uile',
            amount: 'Méid',
            driverName: 'Tiománaí/Feithicil Uimh.',
            station: 'Stáisiún',
            kwh: 'kWh',
            price_per_kwh: 'Praghas/kWh',
            net_value: 'Luach glan',
            vat_rate: 'Ráta CBL',
            gross_value: 'Luach Comhlán',
            totalBeforeVAT: 'Iomlán Roimh CBL',
            VatAt: ' CBL ag',
            VatRate: 'Ráta CBL:',
            totalNetAmount: 'Glanmhéid Iomlán',
            subTotal: 'Fo-iomlán',
            adjustedAmount: 'Méid Coigeartaithe',
            grandTotal: 'Iomlán mhór',
            totalFee: ' Táille Iomlán',
            invoiceNumber: 'Uimhir sonrasc',
            invoiceDate: 'Dáta Sonraisc',
            transaction: 'ID Idirbhirt',
            name: 'Ainm',
            date: 'Dáta',
            publicCardId: 'Aitheantas Cárta Poiblí',
            stationId: 'Aitheantas an stáisiúin',
            transactionStartDate: 'Dáta Tosaigh an Idirbhirt',
            transactionEndDate: 'Dáta Deiridh an Idirbhirt',
            stationAddress: 'Seoladh an Stáisiúin',
            driverAccountId: 'Aitheantas cuntais tiománaí',
            vat_amount: 'Méid CBL',
            stationName: 'Ainm an Stáisiúin',
            status: 'Stádas',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            back: 'Ar ais',
            export: 'Easpórtáil',
        },
        placeholder: {
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            startDateFrom: 'Dáta Tosaigh Ó',
            startDateTo: 'Dáta Tosaigh Chuig',
            select: {
                organisation: 'Roghnaigh Eagraíocht',
                invoice: 'Roghnaigh Uimhir Sonraisc',
            },
        },
        message: {
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            organisation: {
                required: 'Roghnaigh Eagraíocht le do thoil',
            },
            selectRecordToExport: 'Roghnaigh aon taifid le heaspórtáil.',
        },
    },
    driverVehicleAccount: {
        title: 'Cuntais Tiománaithe/Feithiclí : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Cuntais Tiománaithe/Feithiclí',
        managedriver: 'Tiománaí / Feithicil a bhainistiú',
        importHeader: 'Íosluchtaigh cuntais nua le cártaí RFID',
        importUpdateStatusHeader: 'Cumasaigh/Díchumasaigh Cuntais',
        importUpdateSpendGroupAssociation: 'Comhlachas Grúpa Teorainneacha Caiteachais Tiománaithe a nuashonrú',
        placeholder: {
            name: 'Ainm / Ríomhphost / Feithicle Uimh',
            rfidCardNo: 'Cárta RFID Uimh',
            driverGroups: 'Roghnaigh Grúpaí Tiománaithe',
            status: 'Roghnaigh Stádas',
            first_name: 'Ainm',
            last_name: 'Sloinne',
            email: 'Seoladh ríomhphoist',
            vehicle_no: 'Feithicil Uimh',
            driverGroup: 'Roghnaigh Grúpaí Tiománaithe',
            accountType: 'Roghnaigh Cineál Cuntais',
            publicRFIDCardNo: 'Cuir isteach an Cárta RFID Poiblí Uimh.',
            languagePreference: 'Rogha Teanga',
        },
        label: {
            name: 'Ainm',
            email: 'Ríomhphost',
            vehicleNo: 'Feithicil Uimh',
            group: 'Grúpa',
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            cancelled: 'Ar ceal',
            deleted: 'Scriosta',
            delete: 'Scrios',
            first_name: 'Ainm',
            last_name: 'Sloinne',
            vehicle_no: 'Feithicil Uimh',
            driverGroup: 'Grúpa tiománaí',
            accountType: 'Cineál Cuntais',
            assignRFIDCard: 'Sann Cárta RFID',
            rfidCard: 'Cárta RFID',
            publicRFIDCardNo: 'Cuir isteach an Cárta RFID Poiblí Uimh.',
            assign: 'Sann',
            allocatedRFIDCards: 'Cártaí RFID Leithdháilte',
            file: 'Comhad CSV',
            clickHere: 'Cliceáil anseo',
            downloadTemplate: 'chun teimpléad a íoslódáil',
            errosInImportedFile: 'Earráidí',
            driverVehicleNo: 'Tiománaí/Feithicil Uimh.',
            driverVehicleDetails: 'Sonraí Tiománaithe / Feithicle',
            error: 'Earráid',
            pending: 'Ar feitheamh',
            card_allocated: 'Cárta RFID Leithdháilte',
            driver: 'Tiománaí (Cuntas bunaithe ar Aip Cabhlach)',
            vehicle: 'Feithicil (cuntas bunaithe ar RFID)',
            note: 'Nóta: ',
            accountSetupNote:
                'Beidh ar shealbhóir an chuntais socrú an chuntais a chríochnú laistigh de 24 uair an chloig tríd an ##COMPANY_BRAND_NAME## Fleet App ag baint úsáide as an pasfhocal sealadach a chuirtear ar fáil tríd an ríomhphost.',
        },
        button: {
            import: 'Iompórtáil',
            add: 'Cuir',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            edit: 'Cuir in eagar',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            delete: 'Scrios',
            yes: 'Tá',
            no: 'Níl',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            assignRFIDCard: 'Sann Cárta RFID',
            assign: 'Sann',
            action: 'Gníomh',
            done: 'Déanta',
            sendEmail: 'Seol Ríomhphost',
            enableDisableAccounts: 'Cumasaigh/Díchumasaigh Cuntais',
            export: 'Easpórtáil',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            sendMailConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat ríomhphost a sheoladh?',
            mailSentSuccessMessage: 'Seoladh ríomhphoist go rathúil.',
        },
        errors: {
            invalidEmail: 'Cuir isteach seoladh ríomhphoist bailí.',
            invalidFirstName: 'Cuir isteach céad ainm bailí.',
            invalidLastName: 'Cuir isteach sloinne bailí le do thoil.',
            invalidVehicleNo: 'Cuir isteach feithicil bhailí uimh.',
            common: 'Tharla earráid, bain triail eile as.',
        },
        account_type: {
            driver: 'Tiománaí',
            vehicle: 'Feithicil',
        },
        columns: {
            public_rfid_card_no: 'Cárta Uimh',
            allocatedBy: 'Leithdháilte ag',
            allocatedDate: 'Dáta Leithdháilte',
            status: 'Stádas',
        },
    },
    chargingHistory: {
        header: 'Seisiúin Muirearú - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        title: 'Seisiúin Muirearú',
        label: {
            exportAll: 'Easpórtáil',
            location: 'Suíomh',
            date: 'Dáta',
            milesAdded: 'Mílte Curtha leis',
            time: 'Am',
            cost: 'Costas',
            energy: 'Fuinneamh',
            action: 'Gníomh',
            remark: 'Nótaí',
            name: 'Ainm',
            vehicleNo: 'Feithicil Uimh',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            back: 'Ar ais',
        },
        placeholder: {
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            startDateFrom: 'Dáta Tosaigh Ó',
            startDateTo: 'Dáta Tosaigh Chuig',
            driver: 'Ainm / Ríomhphost / Feithicle Uimh',
            selectDriverGroup: 'Roghnaigh Grúpaí Tiománaithe/Feithiclí',
        },
        errors: {
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            selectRecordToExport: 'Roghnaigh aon taifid le heaspórtáil.',
            common: 'Tharla earráid, bain triail eile as.',
        },
    },
    paymentHistory: {
        header: 'Stair Íocaíochta- ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        title: 'Stair Íocaíochta',
        invoiceHeader: 'Sonraí Sonraisc- ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        invoiceTitle: 'Sonrasc Sonraisc',
        label: {
            remark: 'Nótaí',
            credit: 'Creidmheas',
            debit: 'Dochar',
            closing: 'Deiridh',
            transaction: 'ID Idirbhirt',
            name: 'Ainm',
            date: 'Dáta',
            amount: 'Méid',
            driverName: 'Tiománaí/Feithicil Uimh.',
            station: 'Stáisiún',
            kwh: 'kWh',
            price_per_kwh: 'Praghas/kWh',
            net_value: 'Luach glan',
            vat_rate: 'Ráta CBL',
            gross_value: 'Luach Comhlán',
            totalBeforeVAT: 'Iomlán Roimh CBL',
            VatAt: ' CBL ag',
            totalFee: ' Táille Iomlán',
            invoiceNumber: 'Uimhir sonrasc',
            invoiceDate: 'Dáta Sonraisc',
            publicCardId: 'Aitheantas Cárta Poiblí',
            stationId: 'Aitheantas an stáisiúin',
            transactionStartDate: 'Dáta Tosaigh an Idirbhirt',
            transactionEndDate: 'Dáta Deiridh an Idirbhirt',
            stationAddress: 'Seoladh an Stáisiúin',
            driverAccountId: 'Aitheantas cuntais tiománaí',
            vat_amount: 'Méid CBL',
            stationName: 'Ainm an Stáisiúin',
        },
        csvHeader: {
            transaction: 'ID Idirbhirt',
            publicCardId: 'Poiblí_Cárta_ID',
            stationId: 'Aitheantas_stáisiúin',
            transactionStartDate: 'Idirbheart_Tosaithe_Dáta',
            transactionEndDate: 'Idirbheart_Deireadh_Dáta',
            stationAddress: 'Stáisiún_Seoladh',
            driverAccountId: 'Tiománaí_Cuntas_Aitheantas',
            vat_amount: 'CBL_Méid',
            stationName: 'Stáisiún_Ainm',
            kwh: 'kWh_seachadta',
            price_per_kwh: 'Praghas_Per_kWh',
            net_value: 'Glan_Luach',
            vat_rate: 'Ráta_CBL',
            gross_value: 'Comhlán_Luach',
            invoiceNumber: 'Uimhir sonrasc',
            driverName: 'Tiománaí_Ainm',
        },
        placeholder: {
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            export: 'Easpórtáil',
        },
        errors: {
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            selectRecordToExport: 'Roghnaigh aon taifid le heaspórtáil.',
        },
    },
    configurations: {
        title: 'Cumraíochtaí : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Cumraíochtaí',
        columns: {
            name: 'Ainm',
            value: 'Luach',
            description: 'Cur síos',
            system_type: 'Cineál Córais',
            modifiedBy: 'Athraithe De réir',
            modifiedDate: 'Dáta Athraithe',
            action: 'Gníomh',
        },
        button: {
            save: 'Sábháil',
            cancel: 'Cealaigh',
            reset: 'Athshocraigh',
            search: 'Cuardach',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
        },
        note: "RABHADH: D'fhéadfadh tionchar suntasach a bheith aige ar fheidhmíocht an ardáin má athraítear na socruithe cumraíochta seo. ",
        errors: {
            maxLengthString: 'Cuir isteach luach a bhfuil an t-uasmhéid aige',
            maxLengthStringCharacters: 'carachtair',
            maxLengthNUmberCharacters: 'digití',
            valueBetween: 'Cuir isteach luach idir',
            valueGraterThen: 'Cuir isteach luach cothrom nó níos mó ansin',
            valueMention: 'Tabhair luach sa raon luaite',
        },
        placeholder: {
            value: 'Cuir isteach luach',
            description: 'Iontráil cur síos',
            name: 'Ainm',
            valueSearch: 'Luach',
            descriptionSearch: 'Cur síos',
            referenceCode: 'Cód Tagartha',
            systemType: 'Roghnaigh Cineál Córais',
        },
        label: {
            value: 'Luach',
            dataType: 'Cineál Sonraí',
            description: 'Cur síos',
            system: 'CÓRAS',
            driver: 'TIOMÁNAITHE',
            admin: 'RIARACHÁN',
            referenceCode: 'Cód Tagartha',
        },
    },
    rfidRequests: {
        title: 'Iarratais Cártaí RFID - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        header: 'Iarratais Cártaí RFID',
        placeholder: {
            nameEmail: 'Ainm / Ríomhphost',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            publicCardNo: 'Cuir isteach an Cárta Poiblí Uimh',
            enterComments: 'Cuir isteach Do Thuairimí',
            status: 'Roghnaigh Stádas',
            publicRFIDCardNo: 'Cuir isteach an Cárta RFID Poiblí Uimh.',
            scanReqQR: 'Scan an cód QR priontáilte ar an litir',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            add: 'Cuir',
            done: 'Déanta',
            action: 'Gníomh',
            assign: 'Sann',
            downloadPdf: 'Íoslódáil PDF iarratais',
            downloadPdfSelected: 'Íoslódáil PDF le haghaidh Iarratais Roghnaithe',
            downloadPendingApprovedPdf: 'Íoslódáil go léir ar feitheamh',
        },
        columns: {
            name: 'Ainm',
            email: 'Ríomhphost',
            requestedDate: 'Dáta Iarrtha',
            noofCardReq: 'Líon an Chárta a Iarrtar',
            noofCardAllocated: 'Líon an Chárta a Leithdháileadh',
            requestStatus: 'Stádas Iarratas',
            status: 'Stádas',
            driverStatus: 'Stádas tiománaí',
            action: 'Gníomh',
            public_rfid_card_no: 'Cárta Uimh',
            allocatedBy: 'Leithdháilte ag',
            allocatedDate: 'Dáta Leithdháilte',
            federated_account_type: 'Cineál Cuntais Cónaidhme',
        },
        label: {
            reviewRequest: 'Iarratas ar Athbhreithniú',
            assignRFID: 'Cárta RFID',
            processRFIDRequest: 'Iarratas Próisis',
            noofCardRequested: 'Líon an Chárta a Iarrtar',
            noofCardAllocated: 'Líon an Chárta a Leithdháileadh',
            approved: 'Cheadaigh',
            declined: 'Meath',
            publicCardNo: 'Cuir isteach an Cárta Poiblí Uimh',
            enterComments: 'Cuir isteach Do Thuairimí',
            requestStatus: 'Stádas Iarratas',
            assignRFIDCards: 'Cártaí RFID a shannadh',
            publicRFIDCardNo: 'Cuir isteach an Cárta RFID Poiblí Uimh.',
            allocatedRFIDCards: 'Cártaí RFID Leithdháilte',
            address: 'Seoladh',
            scanReqQR: 'Scan an cód QR priontáilte ar an litir',
            name: 'Ainm',
            requestId: 'Aitheantas Iarratas',
            scanHistory: 'Stair Scanadh',
        },
        message: {
            requestProcessed: "D'éirigh leis an iarratas a phróiseáil",
        },
        errors: {
            approveReject: 'Ceadaigh/Diúltaigh an t-iarratas seo.',
            selectAnyRecord: 'Roghnaigh taifead amháin ar a laghad chun PDF a íoslódáil.',
            reqNumTypeError: 'Cuir isteach aitheantas bailí an iarratais',
        },
        pdfText: {
            dear: 'A chara',
            instavolt: ' ##COMPANY_BRAND_NAME##',
            companyNumber: 'Uimhir chuideachta',
            line1: 'Go raibh maith agat as do chárta RFID a iarraidh tríd an ##COMPANY_BRAND_NAME## Aip, faigh do chárta faoi iamh.',
            line2: 'Chun do chárta a ghníomhachtú, lean na céimeanna thíos le do thoil:',
            step1: '1. Logáil isteach sa App',
            step2: "2. Sa roghchlár roghnaigh 'Settings'",
            step3: "3. Cliceáil ar an rogha 'Mo Cártaí RFID'",
            step4: "4. Cliceáil ar an gcnaipe 'Cuir Cárta RFID'",
            step5: '5. Cuir isteach uimhir an chárta atá priontáilte ar an gcárta agus brúigh an cnaipe ‘Ar aghaidh’',
            step6: '6. Tá do chárta gníomhachtaithe anois agus is féidir é a úsáid chun do chéad seisiún muirir eile a thosú',
            line3: 'An raibh a fhios agat gur féidir leat luaíochtaí a thuilleamh gach uair a ghearrann tú táille? ',
            line4: 'Go raibh maith agat as muirearú linn.',
            line5: 'Tá an ##COMPANY_BRAND_NAME## Foireann',
            line6: 'Bonneagar luchtaithe feithiclí leictreacha den scoth a sheachadadh chuig an RA',
        },
    },
    RFIDCardFleets: {
        title: 'Cártaí RFID: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Cártaí RFID',
        placeholder: {
            name: 'Ainm an Tiománaí / Ríomhphost / Uimhir Feithicle',
            manufacturer: 'Monaróir',
            public_card_id: 'Aitheantas Cárta Poiblí',
            status: 'Roghnaigh Stádas',
            mifare_uid: 'AitheantasÚsáideora Mifare',
        },
        label: {
            name: 'Ainm',
            manufacturer: 'Monaróir',
            part_id: 'Cuid Id',
            public_card_id: 'Aitheantas Cárta Poiblí',
            private_card_id: 'Aitheantas Cárta Príobháideach',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            delete: 'Scrios',
            remove: 'Bain Cumann',
            reinstate: 'Athshuiteáil',
            activated: 'Gníomhachtaithe',
            available: 'Ar fáil',
            duplicate: 'Dúblach',
        },
        button: {
            search: 'Cuardach',
            cancel: 'Cealaigh',
            add: 'Cuir',
            assing: 'Sann Cárta RFID',
            import: 'Iompórtáil comhad',
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            reset: 'Athshocraigh',
            yes: 'Tá',
            no: 'Níl',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            action: 'Gníomh',
            back: 'Ar ais',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            getCredentials: 'Faigh Dintiúir',
            delete: 'Scrios',
            remove: 'Bain Cumann',
            reinstate: 'Athshuiteáil',
            exportAll: 'Easpórtáil Uile',
        },
        message: {
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            removeConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat Cumann Cártaí RFID a bhaint go Cuntas',
            reinstateConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat an Cárta RFID a chur ar ais?',
        },
        insert: {
            header: 'Bainistigh cártaí RFID',
            placeholder: {
                manufacturer: 'Ainm Monaróra',
                part_id: 'Cuid Id',
                public_card_id: 'Aitheantas cárta poiblí',
                private_card_id: 'Aitheantas Cárta Príobháideach',
                mifare_uid: 'AitheantasÚsáideora Mifare',
            },
            label: {
                manufacturer: 'Monaróir',
                part_id: 'Cuid Id',
                public_card_id: 'Aitheantas cárta poiblí',
                private_card_id: 'Aitheantas Cárta Príobháideach',
                mifare_uid: 'AitheantasÚsáideora Mifare',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm bailí',
                },
                code: {
                    valid: 'Cuir isteach Cód bailí',
                },
                url: {
                    valid: 'Caithfidh URL a bheith ina URL bailí',
                },
            },
        },
        assignCards: {
            header: 'Sann Cárta RFID',
            label: {
                driver: 'Tiománaí / Feithicil',
            },
            button: {
                yes: 'Sann',
                no: 'Cealaigh',
            },
            form: {
                driver: 'Tiománaí / Feithicil',
                placeholder: {
                    driver: 'Roghnaigh Tiománaí / Feithicil',
                },
            },
        },
        disableCards: {
            header: 'Díchumasaigh',
            header2: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            placeholder: {
                comment: 'Cuir isteach trácht',
            },
            label: {
                comment: 'Trácht',
            },
            button: {
                yes: 'Tá',
                no: 'Níl',
            },
        },
        importCards: {
            header: 'Iompórtáil Cártaí RFID',
            placeholder: {
                file: 'Roghnaigh comhad CSV',
            },
            label: {
                file: 'Comhad CSV',
            },
            button: {
                yes: 'Iompórtáil',
                no: 'Cealaigh',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                file: {
                    fileType: "Is féidir comhad leis an síneadh '.csv' a uaslódáil.",
                },
            },
        },
        importCardsDetails: {
            header: 'Sonraí Iompórtála Cártaí RFID',
            label: {
                unSuccessfullImport: 'Ní féidir na cártaí seo a leanas a iompórtáil',
                successfullImport: 'D’éirigh le hiompórtáil na gcártaí seo a leanas',
                failerReason: 'Cúis teipe',
                publicCardId: 'ID Cárta Poiblí',
            },
            message: {
                defualtErrorMessage: 'Tá fadhb ann leis na cártaí seo a iompórtáil.',
            },
        },
    },
    myProfile: {
        title: 'Mo phróifíl : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Mo phróifíl',
        subheader: {
            details: 'Sonraí pearsanta',
            security: 'Slándáil',
            password: 'Pasfhocal',
        },
        label: {
            firstName: 'Ainm',
            lastName: 'Sloinne',
            email: 'Ríomhphost',
            phoneNo: 'Fón Uimh.',
            currentPassword: 'Pasfhocal reatha',
            newPassword: 'Focal Faire Nua',
            confirmPassword: 'Athdhearbhaigh Pasfhocal',
            mfaAuthentication: 'Fíordheimhniú 2FA',
            authentication: 'Fíordheimhniú',
            securityCode: 'Cód slándála',
            languagePreference: 'Rogha Teanga',
        },
        placeholder: {
            firstName: 'Ainm',
            lastName: 'Sloinne',
            email: 'Ríomhphost',
            phoneNo: 'Fón Uimh.',
            currentPassword: 'Pasfhocal reatha',
            newPassword: 'Focal Faire Nua',
            confirmPassword: 'Athdhearbhaigh Pasfhocal',
            securityCode: 'Cód slándála',
            languagePreference: 'Rogha Teanga',
        },
        button: {
            save: 'Sábháil',
            cancel: 'Cealaigh',
            update: 'Nuashonrú',
            ok: 'ceart go leor',
        },
        toast: {
            profileSuccess: "D'éirigh leis an bpróifíl a nuashonrú.",
            profileError: 'Níl an phróifíl nuashonraithe. ',
            passwordChange: "D'éirigh le hathrú pasfhocal.",
            passwordErr: 'Ní athraítear pasfhocal go rathúil. ',
            passwordWrong: 'Tá an pasfhocal reatha mícheart.',
            securityStop: 'Tá slándáil fíordheimhnithe 2FA stoptha.',
            error: 'Chuaigh rud eigin mícheart. ',
            securitySetupSuccess: 'Tá fíordheimhniú 2FA socraithe go rathúil.',
            securitySetupError: 'Níl fíordheimhniú 2FA socraithe go rathúil. Bain triail eile as ar ball.',
            securityCodeInvalid: 'Cód slándála neamhbhailí.',
        },
        errors: {
            securityCode: {
                match: 'Cuir isteach cód bailí',
                inValid: 'Cuir isteach cód 6 dhigit le do thoil',
            },
            password: {
                confirmPasswordMatch: 'Ní hionann pasfhocal nua agus pasfhocal athdhearbhaithe.',
            },
        },
    },
    apiCredentials: {
        title: 'Dintiúir API : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Dintiúir API',
        button: {
            generate: 'Gin Chomhartha',
            regenerate: 'Athghin Chomhartha',
            yes: 'Tá',
            no: 'Níl',
        },
        note_no_permission:
            'Níl cearta agat rochtain a fháil ar an API.  ##COMPANY_BRAND_NAME## riarthóir chun rochtain a fháil.',
        note_generte_token: 'Is féidir leat an comhartha a ghiniúint trí chliceáil ar "Gin Chomhartha"',
        note: 'Is féidir leat an comhartha a athghiniúint trí chliceáil ar "Athghin Chomhartha"',
        label: {
            token: 'Comhartha',
            generate: 'Gin Chomhartha',
            regenerate: 'Athghin Chomhartha',
        },
        message: {
            regenerateConfirmMesage:
                'An bhfuil tú cinnte gur mian leat Comhartha a Athghiniúint? <br/> Nuair a athghinfidh tú an seanchomhartha beidh sé neamhbhailí agus ní bheidh tú in ann rochtain a fháil ar an API ón seancheann.',
            generateConfirmMesage: 'An bhfuil tú cinnte gur mian leat Gin Chomhartha?',
        },
    },
    cookiePolicy: {
        text: 'Úsáideann an suíomh Gréasáin seo fianáin chun eispéireas an úsáideora a fheabhsú.  ',
        action: 'Polasaí Fianán',
        iAccept: 'Glacaim',
    },
    paymentconfig: {
        title: 'Íocaíocht - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        header: 'Íocaíocht',
        processingNote: "Fan le do thoil agus d'idirbheart á phróiseáil",
        purchaseOrderNote: 'Tá a ##PAYMENT_SCHEDULE## timthriall billeála.  ',
        description: 'Íocaíocht le ##COMPANY_BRAND_NAME##',
        note: 'Beidh post cúlra ar siúl gach seachtain chun billí gan íoc a ghlanadh le haghaidh luchtú feithiclí leictreacha a fheidhmíonn Tiománaithe/Feithiclí ',
        addReplaceCardNote:
            'Tabhair faoi deara le do thoil agus cárta íocaíochta á chur leis beidh do chuntas chun dochair ##CURRENCY_SYMBOL_WITH_VALUE## a chuirfear chun sochair do ##COMPANY_BRAND_NAME## cothromaíocht sparán.',
        label: {
            currentBalance: 'Iarmheid reatha',
            closingBalance: 'Iarmhéid Deiridh',
            availableCredit: 'Creidmheas ar Fáil',
            unbilledAmount: 'Méid Neamhbhilleáilte',
            cardTitle: 'Ainm ar Chárta',
            cardNumber: 'Uimhir chárta',
            expiry: 'Éaga',
            note: 'Nóta : ',
            CSC: 'CSC',
            cardSecurityCode: '(Cód Slándála Cárta)',
            charityDonation: 'Síntiús Carthanachta',
            roundUp: 'Bhabhta suas',
            topUp: 'Barr Suas',
            expires: 'In éag',
            charity: 'carthanacht',
        },
        placeholder: {
            cardTitle: 'Ainm ar Chárta',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00.00',
        },
        button: {
            save: 'Sábháil',
            edit: 'Cuir in eagar',
            replace: 'Ionadaigh',
            back: 'Ar ais',
            payNow: 'Íoc anois',
        },
        errors: {
            CSC: {
                min: 'Cuir isteach cód 3 dhigit íosta.',
            },
            topupAmount: {
                min: 'Ní mór don Mhéid Carthanachta a bheith níos mó ná nó cothrom le 0.1',
            },
            cardNumber: {
                inValid: 'Uimhir chárta neamhbhailí',
            },
            commonError: "Tharla earráid agus d'iarratas á phróiseáil, bain triail eile as ar ball.",
            transactionFailed: "Theip ar d'idirbheart, Bain triail eile as.",
        },
        message: {
            cardSaved: "D'éirigh le sonraí an chárta a shábháil",
        },
    },
    refundRequest: {
        title: 'Ceaduithe Aistarraingthe - ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        header: 'Ceaduithe Aistarraingthe',
        accountInfoNote: 'Faisnéis chuntais a iontráladh chun an aistarraingt a chomhlíonadh:',
        completeConfirmNote:
            'Ná comhlánaigh an t-iarratas aistarraingthe seo ach amháin má tá an luach luaite curtha chun sochair agat do chuntas bainc Tiománaithe. ',
        bulkCompleteConfirmNote:
            'Ná comhlánaigh na hiarratais aistarraingthe seo ach amháin má tá an luach luaite curtha chun sochair agat do chuntas bainc an Tiománaithe. ',
        declineConfirmNote:
            'Cinntigh le do thoil go bhfuil cúis chuí curtha isteach agat le diúltú don iarratas, mar go gcuirtear an fhaisnéis seo ar aghaidh chuig an gcustaiméir. ',
        bulkDeclineConfirmNote:
            'Cinntigh le do thoil go bhfuil cúis chuí curtha isteach agat le diúltú do na hiarratais, mar go gcuirtear an fhaisnéis seo ar aghaidh chuig an gcustaiméir. ',
        label: {
            name: 'Ainm',
            reviewRequest: 'Iarratas ar Athbhreithniú',
            driverName: 'Ainm tiománaí',
            driverEmail: 'Ríomhphost tiománaí',
            requestedDate: 'Dáta Iarrtha',
            action: 'Gníomh',
            amount: 'Méid',
            refundRequested: 'Aistarraingt Iarrtha',
            status: 'Stádas',
            accountNumber: 'Uimhir chuntais',
            sortCode: 'Cód Sórtáil',
            enterComments: 'Iontráil Tuairimí',
            pending: 'Ar feitheamh',
            closed: 'Dúnta',
            complete: 'Críochnaigh',
            decline: 'Meath',
            review_by: 'Athbhreithnithe ag',
            review_date: 'Athbhreithnithe Ar',
            approvalRequest: 'Iarratas Faomhadh',
            processRefundRequest: 'Iarratas Aistarraingthe Próisis',
            completeRefundRequest: 'Iarratas Aistarraingthe Críochnaithe',
            bulkCompleteRefundRequest: 'Críochnaigh Iarratais Aistarraingthe',
            declineRefundRequest: 'Iarratas Aistarraingthe Diúltaithe',
            bulkdeclineRefundRequest: 'Iarratais Aistarraingthe Meath',
            export: 'Sonraí Easpórtála',
            bulk: 'Bulc',
        },
        button: {
            decline: 'Meath',
            approve: 'Cheadaigh',
            reset: 'Athshocraigh',
            search: 'Cuardach',
            complete: 'Críochnaigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            yes: 'Tá',
            no: 'Níl',
        },
        placeholder: {
            selectStatus: 'Roghnaigh Stádas',
            enterComments: 'Iontráil Tuairimí',
            name: 'Ainm/Ríomhphost',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Críochnaigh/Diúltaigh an t-iarratas seo.',
            },
            selectWithdrawalApprovals: 'Roghnaigh iarratais aistarraingthe',
        },
    },
    termsAndConditionListing: {
        title: 'Téarmaí ##COMPANY_BRAND_NAME## : Muirearú Mear EV RA',
        header: 'Téarmaí',
        noteDetails: '*Ní mór glacadh leis go bhfuil sé éigeantach chun cuntas a úsáid/a shíniú.',
        label: {
            iAggreeToTermsCondition: 'Aontaím le ',
            note: 'Nóta: ',
            termsAndConditions: 'Téarmaí',
            reviewUpdatedCondition: 'Athbhreithnigh agus glac leis na téarmaí nuashonraithe',
            name: 'Ainm',
        },
        button: {
            accept: 'Glac',
            next: 'Ar aghaidh',
            cancel: 'Cealaigh',
        },
        errors: {
            acceptTermCondition: 'Glac le * Téarmaí éigeantacha',
        },
    },
    adminDashboard: {
        title: 'Baile : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Deais',
        formtitle: 'Bailíochtú Foirme',
        label: {
            filter: 'Scagaire',
            reportTags: 'Clibeanna Tuairisce',
            driverGroup: 'Grúpa tiománaí',
            selectDriverGroup: 'Roghnaigh Grúpaí Tiománaithe',
            selectTags: 'Roghnaigh Clibeanna',
            dateRange: 'Raon Dáta',
            month: 'Mí',
            year: 'Bliain',
            day: 'Lá',
            week: 'Seachtain',
            userSessionTitle: 'Seisiúin tiománaí',
            userSessions: 'Seisiúin tiománaí',
            totalIncomeTitle: 'Suim Ioncaim',
            income: 'Ioncam',
            transactionTitle: 'Meán Idirbheart',
            transaction: 'Idirbheart',
            energy: 'Fuinneamh',
            energyTitle: 'Suim Fuinnimh (kWh)',
            failedPaymentTitle: 'Líon na hÍocaíochta Teipthe',
            failedPayment: 'Theip ar Íocaíocht',
            driverCountTitle: 'Comhaireamh Tiománaí',
            driver: 'Tiománaí',
            accumulatedVolts: 'Volta Carntha',
            claimedVolts: 'Volta Éilithe ',
            outStandingFailPayment: 'Íocaíocht Theip Gan Réiteach',
            outStandingFailedPaymentTitle: 'Íocaíochtaí Teip Gan Réiteach',
            voltsLiability: 'Dliteanas Volta',
            voltsAccumulatedTitle: 'Volta carntha',
            volts: 'Volta',
            voltsClaimedTitle: 'Volta Éilithe',
            lapsedVolts: 'Volta Lapsed',
            totalNoOfDriverAccount: 'Líon Iomlán na gCuntas Tiománaithe',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            badDebtor: 'Drochfhéichiúnaí',
            cancelled: 'Ar ceal',
            deleted: 'Scriosta',
            fake_account: 'Cuntas Bréige',
            numberOfReferees: 'Líon na Réiteoirí',
            numberOfReferrers: 'Líon na dTagairteoirí',
            referralPayment: 'Íocaíochtaí Atreoraithe (Réiteoir Tarchuir)',
            referrer: 'Atreoraí',
            referee: 'Réiteoir',
            moneySpent: 'Airgead caite ag Réiteoirí Amháin',
            referralBonus: 'bónas atreoraithe',
            referralPromotion: 'Cur Chun Cinn Atreoraithe',
            overnightAutomated: 'Uathoibrithe Thar Oíche',
            customerManual: 'Lámhleabhar do Chustaiméirí',
            pending: 'Ar feitheamh',
            patnerPromoClicksCount: 'Arduithe Céime Comhpháirtí cliceáil ar chomhaireamh ',
            clicksCount: 'Cliceáil Comhaireamh',
            clicksCountMessage:
                'Roghnaigh Aonair nó Il-roghanna chun Cur Chun Cinn Comhpháirtí a thaispeáint Cliceáil Comhaireamh',
            individualDrivers: 'Cuntais Chumasaithe Tiománaithe',
            organisationDrivers: 'Cuntais Chumasaithe Eagraíochtaí',
            individualAndOrgDriverCount: 'Cuntais Chumasaithe: Tiománaithe vs Eagraíochtaí',
            alerts: 'Foláirimh',
            alertsCountTitle: 'Áireamh Foláirimh',
            premiumSubscriptions: 'Síntiúis Préimhe',
            activeSubscriptions: 'Síntiúis Préimhe Iomlána Gníomhacha',
            newSubscriptions: 'Síntiúis Nua',
            cancelledSubscriptions: 'Síntiúis Cealaithe',
            subscriptions: '(Síntiúis)',
        },
        placeholder: {
            patnerPromotions: 'Roghnaigh promóisean comhpháirtí amháin nó níos mó chun sonraí a thaispeáint',
        },
        button: {
            apply: 'Cuir iarratas isteach',
            clear: 'Glan',
            syncData: 'Sonraí Sioncrónaigh',
        },
    },
    footer: {
        version: 'Leagan',
        copyRightText: 'Gach ceart ar cosaint',
    },
    cardReader: {
        title: 'Léitheoirí Cárta: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Léitheoirí Cárta',
        manageCardReader: 'Bainistigh Léitheoir Cárta',
        importHeader: 'Léitheoirí Cárta Iompórtáil',
        button: {
            import: 'Iompórtáil',
            add: 'Cuir',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            edit: 'Cuir in eagar',
            action: 'Gníomh',
            delete: 'Scrios',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            disable: 'Díchumasaigh',
            duplicate: 'Dúblach',
            active: 'Gníomhach',
            chargeStation: 'Stáisiúin Táille',
            yes: 'Tá',
            no: 'Níl',
            claimCardReader: 'Éileamh Léitheoirí Cárta Neamh-leithdháilte',
            claim: 'Éileamh',
        },
        label: {
            description: 'Cur síos',
            latitude: 'Domhanleithead',
            longitude: 'Domhanfhad',
            serialNumber: 'Sraithuimhir',
            endPoint: 'Pointe Deiridh',
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            delete: 'Scrios',
            csvFile: 'Comhad CSV',
            clickHere: 'Cliceáil anseo',
            downloadTemplate: 'chun teimpléad a íoslódáil',
            evse_id: 'ID EVSE',
            error: 'Earráid',
            errorDetail: 'Sonraí Earráide',
            failureReason: 'Cúis Teip',
            id: 'ID léitheoir cárta',
        },
        placeholder: {
            description: 'Cur síos',
            latitude: 'Domhanleithead',
            longitude: 'Domhanfhad',
            serialNumber: 'Sraithuimhir',
            endPoint: 'Sáraigh an Pointe Deiridh',
            selectStatus: 'Roghnaigh Stádas',
        },
        errors: {
            latitude: {
                min: 'Caithfidh domhanleithead a bheith idir -90.0 agus 90.0',
                max: 'Caithfidh domhanleithead a bheith idir -90.0 agus 90.0',
                number: 'Caithfidh domhanleithead a bheith ina uimhir',
            },
            longitude: {
                min: 'Caithfidh fad a bheith idir -180.0 agus 180.0',
                max: 'Caithfidh fad a bheith idir -180.0 agus 180.0',
                number: 'Caithfidh gur uimhir é an Domhanfhad',
            },
            serial_number: {
                valid: 'Cuir isteach sraithuimhir bhailí',
            },
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            duplicateConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat dúbailt?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            activeConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a bheith gníomhach?',
        },
        assign: {
            header: 'Stáisiúin Táille',
            headerModal: 'Stáisiún Táille',
            placeholder: {
                name: 'Cuir isteach ainm',
                address: 'Seoladh',
                tags: 'Roghnaigh Clibeanna',
            },
            label: {
                add: 'Cuir',
                address: 'Seoladh',
                city: 'Cathair',
                name: 'Ainm',
                type: 'Cineál',
                physical_reference: 'Tagairt Fhisiceach',
                postcode: 'Cód Poist',
                action: 'Gníomh',
                delete: 'Scrios',
            },
            button: {
                delete: 'Scrios',
            },
            message: {
                deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            },
        },
    },
    cardScheme: {
        title: 'Scéimeanna Cárta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Scéimeanna Cártaí',
        manageCardScheme: 'Bainistigh Scéim na gCártaí',
        label: {
            TransIdSeed: 'Síl ID Idirbheart',
            keybEncrKey: 'Eochair Chriptiú KeyB',
            transIdEncrKey: 'Eochair Chriptithe Aitheantais Idirbhirt',
            emspCode: 'Cód EMSP',
            endPoint: 'Pointe Deiridh',
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            delete: 'Scrios',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
        },
        button: {
            import: 'Iompórtáil',
            add: 'Cuir',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            edit: 'Cuir in eagar',
            action: 'Gníomh',
            delete: 'Scrios',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            disable: 'Díchumasaigh',
            enable: 'Cumasaigh',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
        },
        placeholder: {
            emspCode: 'Cód EMSP',
            keybEncrKey: 'Eochair Chriptiú KeyB',
            transIdEncrKey: 'Eochair Chriptithe Aitheantais Idirbhirt',
            TransIdSeed: 'Síl ID Idirbheart',
        },
        errors: {
            emsp_code: {
                valid: 'Cuir isteach cód bailí EMSP',
            },
            transaction_id_seed: {
                valid: 'Cuir isteach síol aitheantais idirbheart bailí',
                min: 'Ní féidir le síol id idirbhirt a bheith níos lú ná 0',
                max: 'Uasteorainn bainte amach maidir le síol aitheantais idirbhirt',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Próifíl Eagraíochta',
        message: {
            success: "D'éirigh le próifíl eagraíochta a nuashonrú",
        },
    },
    dataAggregator: {
        title: 'Comhbhailitheoirí Sonraí : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Comhbhailitheoirí Sonraí',
        button: {
            add: 'Cuir',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            edit: 'Cuir in eagar',
            yes: 'Tá',
            no: 'Níl',
            action: 'Gníomh',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            syncDataAggregatorAPIKeys: 'Sioncronaigh Eochracha API le Pleananna Úsáide',
        },
        placeholder: {
            name: 'Ainm',
            status: 'Roghnaigh Stádas',
        },
        label: {
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            name: 'Ainm',
            party_id: 'Aitheantas an Pháirtí',
            country_code: 'Cód Tíre',
            version_url: 'URL an leagan',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
        },
        message: {
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        insert: {
            header: 'Bainistigh Comhbhailitheoir Sonraí',
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm bailí an Chomhbhailitheora Sonraí',
                },
                party_id: {
                    valid: 'Cuir isteach Aitheantas Comhpháirtí bailí',
                },
                country_code: {
                    valid: 'Cuir isteach Cód Tíre bailí',
                },
                version_url: {
                    url: 'Caithfidh URL an leagain a bheith ina URL bailí',
                },
                token: {
                    valid: 'Cuir isteach comhartha bailí',
                },
            },
            placeholder: {
                name: 'Ainm',
                party_id: 'Aitheantas an Pháirtí',
                country_code: 'Cód Tíre',
                version_url: 'Leagan URL an Chomhbhailitheora Sonraí',
                token_a: 'Comhartha A',
                token_b: 'Comhartha B',
                token_c: 'Comhartha C',
                emsp: 'EMSP',
                access_group: 'Grúpa Rochtana',
                usagePlan: 'Plean Úsáide',
            },
            label: {
                name: 'Ainm',
                party_id: 'Aitheantas an Pháirtí',
                country_code: 'Cód Tíre',
                version_url: 'URL an leagan',
                emsp: 'EMSP',
                token_a: 'Comhartha A',
                token_b: 'Comhartha B',
                token_c: 'Comhartha C',
                allow_locations_to_be_extracted: 'Ná lig ach láithreacha a bhaint as an EMPS',
                allow_receive_location_update:
                    'Ceadaigh nuashonruithe suímh PUT(tús tosaigh) agus PATCH (nuashonrú Stádais) a fháil',
                access_group: 'Grúpa Rochtana',
                allow_tariff_extraction: 'Áiríonn Taraif',
                usagePlan: 'Plean Úsáide',
            },
        },
    },
    accessGroups: {
        title: 'Grúpaí Rochtana : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Grúpaí Rochtana',
        manageAccessGroup: 'Bainistigh Grúpa Rochtana',
        label: {
            createdDate: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            delete: 'Scrios',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            name: 'Ainm',
            description: 'Cur síos',
            access_control_type: 'Cineál Rialú Rochtana',
            allow_public_access: 'Ceadaigh Rochtain Phoiblí',
            managed_by_organisation: 'Á bhainistiú ag an Eagraíocht',
            override_tariff: 'Taraif a Shárú',
            yes: 'Tá',
            no: 'Níl',
            access_code: 'Cód Rochtana',
            deleted: ' (Scriosta)',
        },
        button: {
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            add: 'Cuir',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            deleted: ' (Scriosta)',
            chargeStation: 'Suímh Muirir',
            yes: 'Tá',
            no: 'Níl',
            drivers: 'Tiománaithe',
        },
        placeholder: {
            name: 'Ainm',
            selectStatus: 'Roghnaigh Stádas',
            allow_public_access: 'Ceadaigh Rochtain Phoiblí',
            description: 'Cur síos',
            access_control_type: 'Cineál Rialú Rochtana',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
        },
        assign: {
            header: 'Suímh Muirir',
            headerModal: 'Suímh Muirir',
            placeholder: {
                name: 'Cuir isteach ainm',
                address: 'Seoladh',
                tags: 'Roghnaigh Clibeanna',
                postal_code: 'Cód Poist',
                power_type: 'Roghnaigh Cineál Cumhachta',
            },
            label: {
                add: 'Cuir',
                address: 'Seoladh',
                city: 'Cathair',
                name: 'Ainm',
                type: 'Cineál',
                physical_reference: 'Tagairt Fhisiceach',
                postcode: 'Cód Poist',
                action: 'Gníomh',
                delete: 'Scrios',
            },
            button: {
                delete: 'Scrios',
            },
            message: {
                deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            },
        },
        driverAssign: {
            header: 'Tiománaithe',
            headerModal: 'Tiománaithe',
            placeholder: {
                email: 'Ríomhphost',
                status: 'Stádas',
            },
        },
        errors: {
            name: {
                valid: 'Cuir isteach Ainm bailí',
            },
        },
    },
    accessGroupRequests: {
        title: 'Iarratais Grúpa Rochtana : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Iarratais Grúpa Rochtana',
        columns: {
            name: 'Ainm',
            email: 'Ríomhphost',
            federated_account_type: 'Cineál Cuntais Cónaidhme',
            requested_access_group: 'Grúpa Rochtana Iarrtha',
            requested_date: 'Dáta Iarrtha',
            driver_status: 'Stádas tiománaí',
            request_status: 'Stádas Iarratas',
            action: 'Gníomh',
        },
        button: {
            action: 'Gníomh',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            save: 'Sábháil',
            cancel: 'Cealaigh',
        },
        label: {
            review_request: 'Iarratas ar Athbhreithniú',
            requested_access_group: 'Grúpa Rochtana Iarrtha:',
            approve: 'Cheadaigh',
            decline: 'Meath',
            enterComments: 'Tuairimí',
        },
        placeholder: {
            nameEmail: 'Ainm / Ríomhphost',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
            status: 'Roghnaigh Stádas',
            enterComments: 'Cuir isteach Do Thuairimí',
        },
        errors: {
            approveReject: 'Ceadaigh/Diúltaigh an t-iarratas seo.',
        },
    },
    payByWeb: {
        title: 'Íoc De réir an Ghréasáin: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Íoc De réir an Ghréasáin',
        columns: {
            evse_id: 'ID EVSE',
            status: 'Stádas',
            physical_reference: 'Tagairt Fhisiceach',
            location_name: 'Ainm an tSuímh',
            location_address: 'Seoladh Suímh',
            location_city: 'Suíomh na Cathrach',
            location_postal_code: 'Cód Poist Suíomh',
            pay_by_web_active: 'Íoc De réir an Ghréasáin',
            action: 'Gníomh',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            enablePayByWeb: 'Cumasaigh Íoc De réir an Ghréasáin',
            disabledPayByWeb: 'Díchumasaigh Íoc De réir an Ghréasáin',
            submit: 'Cuir isteach',
            cancel: 'Cealaigh',
        },
        label: {
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            manageUniqueCode: 'Bainistigh Cód Uathúil',
            uniqueCode: 'Cód uathúil',
        },
        message: {
            enableConfirmMesage:
                'An bhfuil tú cinnte gur mhaith leat íoc de réir an Ghréasáin a chumasú do stáisiúin roghnaithe?',
            disableConfirmMesage:
                'An bhfuil tú cinnte gur mian leat íoc ar an nGréasán a dhíchumasú do stáisiúin roghnaithe?',
        },
        placeholder: {
            evse_id: 'ID EVSE',
            status: 'Roghnaigh Stádas',
            physical_reference: 'Tagairt Fhisiceach',
            location_name: 'Ainm an tSuímh',
            location_address: 'Seoladh Suímh',
        },
        errors: {
            unique_code: {
                valid: 'Cuir isteach cód bailí uathúil',
            },
        },
    },
    driverDebt: {
        title: 'Fiach Tiománaí: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Fiach Tiománaí',
        button: {
            download: 'Íosluchtaigh',
            strikeOneLetter: 'Litir Stailc a hAon',
            strikeTwoLetter: 'Litir Stailc a Dó',
            generateStrikeOneLetters: 'Gin Litreacha Stailc a hAon',
            generateStrikeTwoLetters: 'Gin Stailc Dhá Litir',
            runHistory: 'Gin Litreacha Stailc - Stair Rith',
            pastLetters: 'Litreacha san am atá caite',
            regenerateLetters: 'Athghin Litreacha',
            refreshPastLetters: 'Athnuaigh litreacha ón am atá thart',
        },
        label: {
            pastLetters: 'Litreacha san am atá caite',
            inProgress: '(ar siúl)',
            noDataFound: 'Níor aimsíodh aon sonraí.',
            dynamicFields: 'Réimsí Dinimiciúla',
            clickToCopy: '(cliceáil chun an nodaireacht a chóipeáil)',
            driverName: 'Ainm tiománaí',
            driverDebt: 'Fiach Tiománaí',
            debtAge: 'Aois Fiach',
            driverEmail: 'Ríomhphost tiománaí',
            driverAddress: 'Seoladh tiománaí',
            date: 'Dáta',
            clickToCopyTooltip: 'Cliceáil chun Cóipeáil',
            regenerate: 'Athghin',
            regenerateLetters: 'Athghin Litreacha',
            letterTemplate: 'Teimpléad Litir',
            cancel: 'Cealaigh',
            reportGenerationInProgress: '(Giniúint tuairisce ar siúl)',
            copyDriverIds: 'Cliceáil chun aitheantas tiománaithe a chóipeáil',
        },
        columns: {
            run: 'Rith Uimh.',
            driverIDs: 'Aitheantais Tiománaithe Incháilithe ag an bPointe Rith Seo',
            runTimestamp: 'Rith Stampa Ama',
            strikeType: 'Cineál Stailc',
            initiatedByUser: 'Úsáideoir a Thionscain an Rith',
            regenerate: 'Athghin',
            action: 'Gníomh',
            relatedRun: 'Rith Gaolmhar Uimh.',
            date: 'Dáta',
            file: 'Comhad',
            templateUsed: 'Teimpléad Úsáidte',
            generatedBy: 'Ginte Ag',
        },
        placeholder: {
            strikeOneLetter: 'Roghnaigh Litir Stailc a hAon',
            strikeTwoLetter: 'Roghnaigh Litir Stailc a Dó',
        },
    },
    fleetAccessGroups: {
        title: 'Iarratais Grúpa Rochtana : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
    },
    emailLogs: {
        title: 'Logchomhaid Ríomhphost : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Logchomhaid Ríomhphoist',
        columns: {
            recipient: 'Faighteoir',
            subject: 'Ábhar',
            deliveryStatus: 'Stádas Seachadta',
            errorMessage: 'Teachtaireacht Earráid',
            createdDate: 'Dáta Cruthaithe',
        },
        label: {
            viewError: 'Earráid Amharc',
        },
        placeholder: {
            recipient: 'Faighteoir',
            subject: 'Ábhar',
            deliveryStatus: 'Stádas seachadta',
            errorMessage: 'Teachtaireacht Earráid',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
        },
    },
    alerts: {
        title: 'Logchomhaid Earráide OCPI : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Logchomhaid Earráide OCPI',
        columns: {
            api: 'url',
            api_call_type: 'Cineál Glaonna API',
            api_request_type: 'Cineál Iarratas',
            response_code: 'Cód Freagartha',
            error_message: 'Teachtaireacht Earráid',
            alert_type: 'Cineál Foláirimh',
            created_date: 'Dáta Cruthaithe',
            request_body: 'Comhlacht Iarratas',
            response_body: 'Comhlacht Freagartha',
        },
        placeholder: {
            api: 'url',
            alert_type: 'Cineál Foláirimh',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
        },
        label: {
            viewDetails: 'Sonraí Amharc',
            errorLogDetails: 'Sonraí Loga Earráide OCPI',
        },
    },
    SubscriptionSetting: {
        title: 'Síntiúis Phréimh : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Síntiúis Préimhe',
        manageSubscription: 'Bainistigh Síntiús Préimhe',
        label: {
            subscription_type: 'Cineál Síntiúis',
            subscription_amount: 'Méid Síntiúis',
            free_subscription_duration: 'Tréimhse síntiús saor in aisce,',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            maximum_routing_call: 'Glaonna Ródúcháin Uasta (In aghaidh na Míosa)',
            additional_volts_per_kwh: 'Volta(í) Breise Luaíocht / kWh',
            name: 'Ainm',
            description: 'Cur síos',
            subscriptionImage: 'Íomhá Síntiúis Préimh',
            exportSubscribersList: 'Easpórtáil Liosta Síntiúsóirí',
            downloadSubscribersList: 'Íoslódáil liosta de na síntiúsóirí',
        },
        placeholder: {
            subscription_amount: 'Méid Síntiúis',
            free_subscription_duration: 'Fad Síntiúis In Aisce (Laethanta)',
            maximum_routing_call: 'Glaonna Ródúcháin Uasta',
            name: 'Ainm',
            status: 'Roghnaigh Stádas',
            subscriptionType: 'Roghnaigh Cineál Síntiúis',
            subscriptionImage: 'Roghnaigh Íomhá Síntiúis Préimh',
        },
        button: {
            action: 'Gníomh',
            disable: 'Díchumasaigh',
            enable: 'Cumasaigh',
            edit: 'Cuir in eagar',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            enableDisable: 'Cumasaigh / Díchumasaigh Síntiús',
            add: 'Cuir',
            search: 'Cuardach',
            reset: 'Athshocraigh',
        },
        errors: {
            amount: {
                moreThan: 'Caithfidh an méid a bheith níos mó ná 1',
                lessThan: 'Caithfidh an méid a bheith níos lú ná 100',
                number: 'Ní mór uimhir a bheith i méid',
            },
            duration: {
                moreThan: 'Caithfidh an fad a bheith níos mó ná 1',
                lessThan: 'Ní mór don ré a bheith níos lú ná 180',
            },
            maxRoutingCall: {
                moreThan: 'Caithfidh luach uasta glaonna ródaithe a bheith níos mó ná 1',
                lessThan: 'Ní mór uasluach glaonna ródaithe a bheith níos lú ná 1000',
            },
            additionalVolts: {
                lessThan: 'Caithfidh luach a bheith níos lú ná nó cothrom le 5',
                number: 'Caithfidh luach a bheith ina uimhir',
            },
        },
        message: {
            enableFromConfig:
                "Chun Síntiús Préimhe a chumasú, socraigh 'Cumasaigh Síntiús Préimhe' go 'True' ar dtús i Socruithe > Cumraíochtaí",
            disableConfirmMessage:
                'Rabhadh: Má dhíchumasaítear an Síntiús Préimhe cuirfear ar ceal gach uathoibríoch-athnuachan a bhaineann le Cuntas Tiománaí. ',
            enableConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
        },
    },
    advertisingDevices: {
        title: 'Gléasanna Fógraíochta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Gléasanna Fógraíochta',
        label: {
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            device_name: 'Ainm',
            device_id: 'Aitheantas an Ghléis',
            postal_code: 'Cód Poist',
            charge_station: 'Stáisiún Táille',
            screen_size: 'Méid an Scáileáin',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            delete: 'Scrios',
            operational: 'Oibriúcháin',
        },
        button: {
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            add: 'Cuir',
            reset: 'Athshocraigh',
            search: 'Cuardach',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            assignVideos: 'Físeáin a shannadh',
            yes: 'Tá',
            no: 'Níl',
            regenerateS3File: 'Athghin Comhad S3',
            mediaTerminalLogs: 'Logchomhaid Teirminéil Meán',
        },
        placeholder: {
            device_name: 'Ainm an Ghléis',
            postal_code: 'Cód Poist',
            charge_station: 'Stáisiún Táille',
            selectStatus: 'Roghnaigh Stádas',
            screen_size: 'Méid an Scáileáin',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
        },
        insert: {
            header: 'Bainistigh Gléas Fógraíochta',
            placeholder: {
                device_name: 'Ainm an Ghléis',
                device_id: 'Aitheantas an Ghléis',
                charge_station: 'Stáisiún Táille',
                screen_size: 'Méid an Scáileáin',
            },
            label: {
                device_name: 'Ainm an Ghléis',
                device_id: 'Aitheantas an Ghléis',
                charge_station: 'Stáisiún Táille',
                screen_size: 'Méid an Scáileáin',
            },
            errors: {
                common: 'Tharla earráid, bain triail eile as.',
                name: {
                    valid: 'Cuir isteach ainm bailí',
                },
                device_id: {
                    valid: 'Cuir isteach ID Gléas bailí',
                    min: 'Caithfidh 6 charachtar ar a laghad a bheith in aitheantas an ghléis',
                },
            },
        },
        assignVideos: {
            header: 'Físeáin',
            headerModal: 'Físeáin',
            label: {
                action: 'Gníomh',
                delete: 'Scrios',
            },
            placeholder: {
                file_name: 'Ainm comhaid',
                description: 'Cur síos',
            },
            message: {
                deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            },
        },
    },
    advertisingVideos: {
        title: 'Físeáin Fógraíochta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Físeáin Fógraíocht',
        label: {
            file_name: 'Ainm comhaid',
            description: 'Cur síos',
            operational_start_date: 'Dáta Tosaigh Oibriúcháin',
            operational_end_date: 'Dáta Deiridh Oibriúcháin',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            delete: 'Scrios',
            reviewVideo: 'Físeán Athbhreithnithe',
            approve: 'Cheadaigh',
            reject: 'Diúltaigh',
            videoUpload: 'Físeán',
            comments: 'Tuairimí',
        },
        button: {
            action: 'Gníomh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
            add: 'Cuir',
            reset: 'Athshocraigh',
            search: 'Cuardach',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            reviewVideo: 'Físeán Athbhreithnithe',
            downloadVideo: 'Íosluchtaigh vidio',
            assignDevice: 'Sann Gléasanna',
        },
        placeholder: {
            file_name: 'Ainm comhaid',
            description: 'Cur síos',
            start_date: 'Dáta Tosaigh Oibriúcháin',
            end_date: 'Dáta Deiridh Oibriúcháin',
            selectStatus: 'Roghnaigh Stádas',
            videoUpload: 'Físeán',
            enterComments: 'Cuir isteach do chuid tuairimí',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
        },
        insert: {
            header: 'Bainistigh Físeán Fógraíochta',
            placeholder: {
                description: 'Cur síos',
                operational_start_date: 'Dáta Tosaigh Oibriúcháin',
                operational_end_date: 'Dáta Deiridh Oibriúcháin',
            },
            label: {
                description: 'Cur síos',
                operational_start_date: 'Dáta Tosaigh Oibriúcháin',
                operational_end_date: 'Dáta Deiridh Oibriúcháin',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Le do thoil Faomh/Diúltaigh an t-iarratas seo.',
                },
            },
            name: {
                valid: 'Cuir isteach ainm bailí',
            },
            file_name: {
                fileType: "Is féidir comhad le síneadh '.mp4', '.flv', '.wmv', '.mpeg', '.avi', '.3gp' a uaslódáil",
                uploadError: 'Earráid agus Comhad Físeáin á Uaslódáil',
                required: 'Tá comhad físe ag teastáil',
                fileNameLength: 'Tá uasmhéid 15 carachtar ceadaithe don ainm comhaid',
            },
            file_size: 'Is é an teorainn uasta méid comhaid a uaslódáil',
        },
        assignDevices: {
            header: 'Gléasanna',
            headerModal: 'Gléasanna',
            label: {
                action: 'Gníomh',
                delete: 'Scrios',
            },
            placeholder: {
                device_name: 'Ainm an Ghléis',
                device_id: 'Aitheantas an Ghléis',
                status: 'Stádas',
            },
            message: {
                deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Dintiúir Fógraíochta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Dintiúir Fógraíochta',
        manageCredentials: 'Bainistigh Dintiúir Fógraíochta',
        label: {
            bucket_name: 'Ainm Buicéad',
            region_name: 'Ainm Réigiúin',
            download_access_key: 'Íosluchtaigh eochair do rochtain',
            download_secret_key: 'Íoslódáil an eochair rúnda',
            upload_access_key: 'Íosluchtaigh eochair rochtana',
            upload_secret_key: 'Íoslódáil an eochair rúnda',
            download_info_object_name: 'Íoslódáil an clár faisnéise mar gheall ar an ábhar',
            upload_path: 'Bealach Uaslódáil',
            dialog_password: 'Pasfhocal dialóg',
            expect_bucket_name: 'Bí ag súil le Ainm Buicéad',
            expect_region_name: 'Bí ag súil le hAinm Réigiúin',
            expect_download_access_key: 'Íosluchtaigh eochair rochtana',
            expect_download_secret_key: 'Íoslódáil an eochair rúnda',
            version_code: 'Cód Leagan',
            download_url: 'Íosluchtaigh URL',
            prompt: 'Leid',
            remarks: 'Nótaí',
            modified_by: 'Athraithe De réir',
            modified_date: 'Dáta Athraithe',
            status: 'Stádas',
            action: 'Gníomh',
            enabled: 'Cumasaigh',
            disabled: 'Díchumasaigh',
        },
        button: {
            action: 'Gníomh',
            disable: 'Díchumasaigh',
            enable: 'Cumasaigh',
            edit: 'Cuir in eagar',
            back: 'Ar ais',
            save: 'Sábháil',
            cancel: 'Cealaigh',
        },
    },
    organisationInvoices: {
        title: 'Sonraisc Eagraíochta : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Sonraisc Eagraíochta',
        label: {
            name: 'Eagraíocht',
            invoice_id: 'Aitheantas an tSonraisc',
            invoice_value: 'Luach Sonraisc',
            invoice_date: 'Dáta Sonraisc',
            action: 'Gníomh',
            undo: 'Cealaigh',
            undoPayment: 'Cealaigh Íocaíocht',
            disputed: 'Díospóid',
            adjustAmount: 'Coigeartaigh Luach Sonraisc ',
            paid_value: 'Luach Íoctha',
            outstanding: 'Sármhaith',
            status: 'Stádas',
            comments: 'Tuairimí',
            original_value: 'Bunluach',
        },
        placeholder: {
            name: 'Ainm',
            start_date: 'Dáta tosaigh',
            end_date: 'Dáta deiridh',
            status: 'Stádas',
            organisation: 'Roghnaigh Eagraíocht',
        },
        button: {
            search: 'Cuardach',
            reset: 'Athshocraigh',
            action: 'Gníomh',
            pay: 'Pá',
            partPay: 'Páirt-Íoc',
            undo: 'Cealaigh',
            disputed: 'Díospóid',
            adjustValue: 'Coigeartaigh Luach Sonraisc',
        },
        errors: {
            amount: {
                moreThan: 'Caithfidh an méid a bheith níos mó ná 0',
                maxValue: 'Uasluach bainte amach don mhéid',
                notZero: 'Caithfidh an méid a bheith níos mó/níos lú ná 0',
                minValue: 'Íosluach bainte amach don mhéid',
                number: 'Ní mór uimhir a bheith i méid',
            },
            organisation: {
                required: 'Roghnaigh eagraíocht le do thoil',
            },
        },
        message: {
            undoConfirmMessage:
                "An bhfuil tú cinnte gur mhaith leat an luach íoctha a bhaint agus an stádas a shocrú go 'Sármhaith' don sonrasc seo?",
            disputedConfirmMessage:
                "An bhfuil tú cinnte gur mhaith leat stádas socraithe mar 'Díospóid' don sonrasc seo?",
        },
        payModal: {
            header: 'Pá',
            partPayHeader: 'Páirt-Íoc',
            label: {
                amount: 'Méid',
                date_paid: 'Dáta Íoctha',
                comments: 'Tuairimí',
            },
            placeholder: {
                amount: 'Cuir isteach Méid',
                date_paid: 'Cuir isteach Dáta Íoctha',
                comments: 'Iontráil Tuairimí',
            },
            button: {
                accept: 'Glac',
                send_for_approval: 'Seol Chun Faomhadh',
                cancel: 'Cealaigh',
                submit: 'Cuir isteach',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Logchomhaid Teirminéil Meán : ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Logchomhaid Teirminéil Meán',
        label: {
            file_name: 'Ainm comhaid',
            date_played: 'Dáta Imeartha',
            play_time: 'Am Súgartha',
            start_time: 'Am Tosaigh',
        },
        placeholder: {
            fileName: 'Ainm comhaid',
            startDate: 'Dáta tosaigh',
            endDate: 'Dáta deiridh',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Stair Teorainneacha Caiteacha: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Stair Teorainneacha Caitheamh',
        label: {
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            name: 'Ainm tiománaí',
            email: 'Ríomhphost tiománaí',
            type: 'Cineál Tairseach',
            spend_limit_exceed_date: 'Teorainn Caiteachais os cionn Dáta',
            status: 'Stádas tiománaí',
            action: 'Gníomh',
            export: 'Easpórtáil',
            onStop: 'Ar Stop',
            cancelOnStop: 'Cealaigh Ar Stop',
        },
        button: {
            disable: 'Díchumasaigh',
            enable: 'Cumasaigh',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            yes: 'Tá',
            no: 'Níl',
            back: 'Ar ais',
        },
        placeholder: {
            name: 'Ainm tiománaí',
            email: 'Ríomhphost tiománaí',
            status: 'Roghnaigh Stádas Tiománaí',
            dateFrom: 'Teorainn Níos Mó Dáta De',
            dateTo: 'Teorainn Amach Dáta Go',
            type: 'Roghnaigh Cineál Tairseach',
        },
        message: {
            noDataToExport: 'Níl aon sonraí le heaspórtáil.',
            cancelOnStopConfirmation: 'An bhfuil tú cinnte gur mhaith leat stop a chur leis an stad don tiománaí seo?',
        },
    },
    driverDebtorLetters: {
        title: 'Litreacha Féichiúnaí Tiománaithe: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Litreacha féichiúnaí tiománaí',
        manageDriverDebtorLetter: 'Bainistigh Litir Fhéichiúnaí Tiománaithe',
        label: {
            reportType: 'Cineál Tuairisce',
            defaultLetter: 'Teimpléad Litir Fhéichiúnaí Réamhshocraithe',
            content: 'Ábhar',
            enabled: 'Cumasaithe',
            disabled: 'Faoi mhíchumas',
            created_date: 'Dáta Cruthaithe',
            status: 'Stádas',
            action: 'Gníomh',
            delete: 'Scrios',
            dynamicFields: 'Réimsí Dinimiciúla',
            copyNotation: '(Cliceáil chun an nodaireacht a chóipeáil)',
            clickToCopy: 'Cliceáil chun Cóipeáil',
            driverName: ' • Ainm an Tiománaí',
            driverDebt: '• Fiach Tiománaithe',
            debtAge: '• Aois Fiach',
            driverEmail: '• Ríomhphost Tiománaithe',
            driverAddress: '• Seoladh Tiománaithe',
            date: '• Dáta',
            uniqueReference: '• Tagairt Uathúil',
            useStandardTemplate: 'Úsáid Teimpléad Caighdeánach',
        },
        column: {
            defaultLetter: 'Litir Réamhshocraithe',
        },
        button: {
            setDefaultLetter: 'Socraigh mar réamhshocrú',
            enable: 'Cumasaigh',
            disable: 'Díchumasaigh',
            edit: 'Cuir in eagar',
            delete: 'Scrios',
            createDuplicate: 'Cruthaigh Dúblach',
            save: 'Sábháil',
            cancel: 'Cealaigh',
            preview: 'Réamhamharc',
        },
        message: {
            setDefaultConfirmMesage:
                'An bhfuil tú cinnte gur mhaith leat an Litir Féichiúnaí seo a shocrú mar réamhshocrú?',
            enableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a chumasú?',
            disableConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a dhíchumasú?',
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
        },
        error: {
            emptyContent: 'Cuir inneachar ar fáil chun an Teimpléad Litreach a réamhamharc',
            common: "Tharla earráid agus d'iarratas á phróiseáil, bain triail eile as ar ball.",
            supportedDynamicField1: 'Na réimsí dinimiciúla seo',
            supportedDynamicField2: 'ní thacaítear leo ach le haghaidh litir féichiúnaí.',
        },
    },
    driverSubscriptions: {
        title: 'Síntiúis Préimh Tiománaithe: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Síntiúis Préimhe',
        label: {
            subscriptionType: 'Cineál Síntiúis',
            subscriptionStartDate: 'Dáta Tosaigh Síntiúis',
            subscriptionStatus: 'Stádas Síntiúis',
            renewalOrExpiryDate: 'Dáta Athnuachana / Éaga',
            voltsCredited: 'Volta a cuireadh chun sochair',
            journeysPlanned: 'Turais Phleanáilte',
            active: 'Gníomhach',
            cancelled: 'Ar ceal',
            action: 'Gníomh',
            cancel: 'Cealaigh',
            cancelSubscription: 'Cealaigh Síntiús',
            terminate: 'Foirceannadh',
            terminateSubscription: 'Foirceannadh Síntiúis',
            freeTrial: 'Triail shaor',
            name: 'Ainm',
            promotion: 'cur chun cinn',
        },
        message: {
            cancelConfirmMessage: 'An bhfuil tú cinnte gur mhaith leat an síntiús don úsáideoir seo a chealú? ',
            terminateConfirmMessage:
                'An bhfuil tú cinnte gur mhaith leat deireadh a chur leis an síntiús don úsáideoir seo? ',
            terminateConfirmMessageWithoutRenew:
                'An bhfuil tú cinnte gur mhaith leat deireadh a chur leis an síntiús don úsáideoir seo? ',
        },
    },
    advertisingDropDownDefaultmessage:
        'Cuir isteach 3 charachtar ar a laghad de shuíomhanna chun liosta na stáisiún a thaispeáint',
    rfidcardDropDownDefaultMessage:
        'Cuir isteach 3 charachtar ar a laghad chun liosta tiománaithe/feithicle a thaispeáint',
    chargeStationMapDropDownDefaultMessage:
        'Cuir isteach 3 charachtar ar a laghad de stáisiún muirir chun stáisiúin muirir a thaispeáint',
    startChargePageDropDownDefaultMessage: 'Iontráil carachtair suíomhanna chun liosta suíomhanna a thaispeáint',
    groupGridDropDownDefaultMessage:
        'Cuir isteach 3 charachtar ar a laghad chun liosta tiománaithe/feithicle a thaispeáint',
    organisationdashBoardDefaultMessage:
        'Cuir isteach 3 charachtar ar a laghad chun liosta tiománaithe/feithicle a thaispeáint',
    rfidAssigncardDefaultDropDownMessage:
        'Cuir isteach 3 charachtar ar a laghad de ríomhphost an tiománaí chun liosta na dtiománaithe a thaispeáint',
    tariffDropDownDefaultMessage: 'Iontráil íosmhéid de 3 charachtar den taraif chun liosta na dtaraifí a thaispeáint',
    limitExceedAddressError: 'Ní féidir an seoladh a aimsiú faoi láthair',
    continueTypingSearch: 'Lean ar aghaidh ag clóscríobh chun an cuardach a chur ina cheart',
    noFileChosen: 'Níor roghnaíodh aon chomhad',
    ChooseFile: 'Roghnaigh Comhad',
    noOptions: 'Gan Roghanna',
    requiredField: 'Is réimse riachtanach é an comhad',
    removeImage: 'Bain Íomhá',
    help: 'Cabhrú',
    editor: {
        bold: 'Trom',
        italic: 'iodálach',
        underline: 'Cuir líne faoi',
        strikeThrough: 'Stailc tríd',
        monospace: 'Monaspás',
        superscript: 'Forscríbhinn',
        subscript: 'Síntiús',
        blockType: 'Cineál Bloc',
        fontSize: 'Méid cló',
        font: 'Cló',
        unordered: 'Neamhordúil',
        ordered: "D'ordaigh",
        indent: 'fleasc',
        outdent: 'Amach',
        left: 'Ar chlé',
        right: 'Ceart',
        center: 'Ionad',
        justify: 'údar',
        colorPicker: 'Roghnóir Dathanna',
        link: 'Nasc',
        unlink: 'Dínascadh',
        embedded: 'Leabaithe',
        emoji: 'Emoji',
        remove: 'Bain',
        undo: 'Cealaigh',
        redo: 'Athdhéan',
        image: 'Íomha',
    },
    map: {
        zoomIn: 'Zúmáil isteach',
        zoomOut: 'Súmáil Amach',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Cuir iarratas isteach',
    cancel: 'Cealaigh',
    noDataFound: 'Tá brón orm! ',
    globalService: {
        title: 'Clárú Seirbhíse Domhanda: ##COMPANY_BRAND_NAME## - Ardán Seirbhíse Ríomhshoghluaisteachta',
        status: {
            pending: 'Chun cumarsáid a dhéanamh leis na seirbhísí domhanda, cuir isteach an fhaisnéis thíos. ',
            registered: 'Is féidir le EMSP Platform cumarsáid a dhéanamh anois leis na seirbhísí domhanda. ',
        },
        insert: {
            url: 'URL',
            handshakeToken: 'Comhartha Croith Láimhe',
        },
        placeholder: {
            url: 'URL',
            handshakeToken: 'Comhartha Croith Láimhe',
        },
        label: {
            note: 'Nóta',
            noteValue:
                "Ní mór 'comhartha croith láimhe' a chur isteach gach uair a shocraítear cumarsáid le seirbhísí domhanda. ",
            rfidSync: 'Sync RFID',
        },
        button: {
            register: 'Clár',
            reRegister: 'Athchláraigh',
        },
        error: {
            errorWhileCreatingGlobalService: 'Earráid agus seirbhís dhomhanda á cruthú.',
            errorWhileUpdatingGlobalService: 'Earráid agus an tseirbhís dhomhanda á nuashonrú.',
        },
        endpointsTable: {
            header: 'Críochphointe Seirbhíse Domhanda',
            column: {
                identifer: 'Aitheantóir',
                httpMethod: 'Http modh',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Miondealú Mionsonraithe',
        total_cost: 'Costas Iomlán',
        conversion_rate: 'Ráta Tiontaithe',
        totalNetCost: 'Costas Glan Iomlán',
        total_parking_cost: 'Costas Iomlán Páirceála',
        total_energy_cost: 'Costas Iomlán Fuinnimh',
        total_fixed_cost: 'Costas Seasta Iomlán',
        total_time_cost: 'Costas Iomlán Ama Muirir',
    },
    SubscriptionImages: {
        title: 'Íomhánna Síntiúis Préimh',
        manageSubscriptionImage: 'Bainistigh Íomhá Síntiúis Préimh',
        label: {
            name: 'Ainm',
            description: 'Cur síos',
            action: 'Gníomh',
            delete: 'Scrios',
            image: 'Íomha',
            language: 'Teanga',
        },
        button: {
            edit: 'Cuir in eagar',
            search: 'Cuardach',
            reset: 'Athshocraigh',
            add: 'Cuir',
        },
        message: {
            deleteConfirmMesage: 'An bhfuil tú cinnte gur mhaith leat a scriosadh?',
        },
        errors: {
            insertEnglishLanguageImage: 'Íoslódáil an pictiúr i mbéarla le do thoil',
            required: 'Tá íomhá ag teastáil.',
        },
    },
    driverPaymentCards: {
        title: 'Cártaí Íocaíochta Tiománaithe : InstaVolt - Ardán Seirbhíse Ríomhshoghluaisteachta',
        header: 'Cártaí Íocaíochta',
        label: {},
    },
};
